/* ============================================================
   SITE SETTINGS — fill these in before launch
   ============================================================ */
window.SITE = {
  email: "contact@lekoindulux.com",   // customer service address
  instagram: "",                      // e.g. "https://www.instagram.com/yourhandle" (empty = link hidden)
  tiktok: "",                         // e.g. "https://www.tiktok.com/@yourhandle" (empty = link hidden)
  orderStatusUrl: "",                 // optional: your Shopify order-status / account page
  signupUrl: "",                      // optional: form endpoint for "Notify me" sign-ups (Formspree, Klaviyo…).
                                      // Empty = sign-ups arrive as emails to the address above.
  womenLive: false,                   // false = Women shows "Coming soon". Set to true on launch day.
  region: "France",                   // shown in the footer
  currency: "USD $",                  // shown in the footer — match the currency your prices use
  payments: ["Visa", "Mastercard", "PayPal", "Apple Pay"]   // payment badges in the footer — list only what you accept
};

/* ============================================================
   MENU — the categories shown in the header and on shop pages
   ============================================================ */
window.MENU = {
  men: {
    clothing: ["T-Shirts", "Jeans", "Shirts", "Hoodies & Sweats", "Outerwear"],
    shoes: ["Sneakers", "Boots", "Loafers", "Sandals"],
    accessories: ["Bags", "Belts", "Wallets"]
  },
  women: {
    clothing: ["T-Shirts", "Jeans", "Dresses", "Hoodies & Sweats"],
    shoes: ["Ballerinas & Loafers", "Sandals", "Mules & Slides", "Sneakers", "Heels"],
    accessories: ["Wallets", "Jewelry", "Bags", "Scarves & Foulards", "Hair Accessories", "Belts"]
  }
};

/* ============================================================
   BRANDS — used to classify men's (and unisex) products
   ============================================================ */
window.BRANDS = [
  "Tommy Hilfiger", "Lacoste", "Calvin Klein", "Hugo Boss", "Massimo Dutti",
  "Nike", "Adidas", "New Balance", "Puma",
  "Gucci", "Prada", "Louis Vuitton", "Dior", "Fendi"
];

/* ============================================================
   PRODUCTS — every product on the site comes from this list.
   gender: "men" | "women" | "unisex"   (unisex shows in both)
   type:   "clothing" | "shoes" | "accessories"
   sub:    one of the MENU names above (e.g. "Sneakers")
   brand:  one of the BRANDS above (optional but recommended for men)
   was:    old price → shows the item in SALE
   isNew:  true → shows in NEW IN      best: true → BEST SELLERS
   sizes:  ["XS","S","M","L","XL"], ["39","40","41"], or ["ONE SIZE"]
   ============================================================ */
window.CATALOG = [
  { id: "jacket", name: "Leather Biker Jacket", gender: "men", type: "clothing", sub: "Outerwear", brand: "Hugo Boss",
    price: 189, isNew: true, best: true, badge: "NEW",
    img: "https://images.unsplash.com/photo-1551028719-00167b16eac5?auto=format&fit=crop&w=1200&q=75",
    desc: "A biker jacket with a clean, structured cut. Asymmetric zip, snap lapels and zipped pockets — built to be worn for years.",
    details: ["Leather outer", "Asymmetric front zip", "Zipped chest and side pockets", "Regular fit"] },
  { id: "hoodie", name: "Oversized Hoodie", gender: "unisex", type: "clothing", sub: "Hoodies & Sweats", brand: "Nike",
    price: 69, best: true,
    img: "https://images.unsplash.com/photo-1556821840-3a63f95609a7?auto=format&fit=crop&w=1200&q=75",
    desc: "A heavyweight hoodie with dropped shoulders and a relaxed, oversized silhouette. The everyday layer.",
    details: ["Brushed fleece interior", "Dropped shoulders", "Kangaroo pocket", "Oversized fit — take your usual size"] },
  { id: "denim", name: "Relaxed Fit Denim", gender: "women", type: "clothing", sub: "Jeans",
    price: 69, was: 99, best: true, badge: "-30%",
    img: "https://images.unsplash.com/photo-1542272604-787c3835535d?auto=format&fit=crop&w=1200&q=75",
    desc: "High-rise jeans with a relaxed leg and a soft washed finish. Easy with a tee, sharp with a blazer.",
    details: ["High rise", "Relaxed straight leg", "Five-pocket design", "Button and zip fly"] },
  { id: "tee", name: "Heavyweight Tee", gender: "men", type: "clothing", sub: "T-Shirts", brand: "Calvin Klein",
    price: 35, best: true,
    img: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?auto=format&fit=crop&w=1200&q=75",
    desc: "A thick, structured cotton tee that keeps its shape. Ribbed crew neck, boxy fit.",
    details: ["Heavyweight cotton jersey", "Ribbed crew neck", "Boxy fit"] },
  { id: "th-polo", name: "Classic Fit Polo", gender: "men", type: "clothing", sub: "T-Shirts", brand: "Tommy Hilfiger",
    price: 79, best: true,
    img: "https://images.unsplash.com/photo-1586790170083-2f9ceadc732d?auto=format&fit=crop&w=1200&q=75",
    desc: "Iconic polo with contrast collar tipping and embroidered flag logo.",
    details: ["Cotton piqué", "Two-button placket", "Regular fit"] },
  { id: "lacoste-polo", name: "L.12.12 Polo", gender: "men", type: "clothing", sub: "T-Shirts", brand: "Lacoste",
    price: 98, isNew: true, badge: "NEW",
    img: "https://images.unsplash.com/photo-1618354691373-d851c5c3a990?auto=format&fit=crop&w=1200&q=75",
    desc: "The original crocodile polo — clean lines, refined finish.",
    details: ["Petit piqué cotton", "Mother-of-pearl buttons", "Regular fit"] },
  { id: "ck-jeans", name: "Slim Denim", gender: "men", type: "clothing", sub: "Jeans", brand: "Calvin Klein",
    price: 98, was: 128, badge: "-23%",
    img: "https://images.unsplash.com/photo-1542272604-787c3835535d?auto=format&fit=crop&w=1200&q=75",
    desc: "Slim-leg denim with a dark wash and subtle stretch.",
    details: ["Mid rise", "Slim leg", "Five-pocket"] },
  { id: "boss-shirt", name: "Slim Fit Oxford", gender: "men", type: "clothing", sub: "Shirts", brand: "Hugo Boss",
    price: 129, best: true,
    img: "https://images.unsplash.com/photo-1596755094514-f87e34085b2c?auto=format&fit=crop&w=1200&q=75",
    desc: "Crisp oxford shirt with a modern slim cut.",
    details: ["Cotton oxford", "Button-down collar", "Slim fit"] },
  { id: "md-blazer", name: "Structured Blazer", gender: "men", type: "clothing", sub: "Outerwear", brand: "Massimo Dutti",
    price: 249, isNew: true, badge: "NEW",
    img: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?auto=format&fit=crop&w=1200&q=75",
    desc: "Tailored blazer in a soft wool blend — desk to dinner.",
    details: ["Wool blend", "Notch lapels", "Regular fit"] },
  { id: "nike-air", name: "Air Max Sneaker", gender: "men", type: "shoes", sub: "Sneakers", brand: "Nike",
    price: 140, best: true, isNew: true, badge: "NEW",
    img: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&w=1200&q=75",
    desc: "Visible Air cushioning and a clean everyday silhouette.",
    details: ["Mesh upper", "Rubber outsole"], sizes: ["40","41","42","43","44","45"] },
  { id: "adidas-samba", name: "Samba OG", gender: "men", type: "shoes", sub: "Sneakers", brand: "Adidas",
    price: 100, best: true,
    img: "https://images.unsplash.com/photo-1608231387042-66d1773070a5?auto=format&fit=crop&w=1200&q=75",
    desc: "Heritage court sneaker with suede overlays and gum sole.",
    details: ["Leather & suede", "Gum rubber outsole"], sizes: ["40","41","42","43","44","45"] },
  { id: "nb-550", name: "550 Sneaker", gender: "men", type: "shoes", sub: "Sneakers", brand: "New Balance",
    price: 120,
    img: "https://images.unsplash.com/photo-1539185441755-769473a23570?auto=format&fit=crop&w=1200&q=75",
    desc: "Retro basketball silhouette with premium materials.",
    details: ["Leather upper", "EVA midsole"], sizes: ["40","41","42","43","44","45"] },
  { id: "puma-suede", name: "Suede Classic", gender: "men", type: "shoes", sub: "Sneakers", brand: "Puma",
    price: 80, was: 95, badge: "-16%",
    img: "https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?auto=format&fit=crop&w=1200&q=75",
    desc: "The street classic — soft suede, low profile.",
    details: ["Suede upper", "Rubber outsole"], sizes: ["40","41","42","43","44","45"] },
  { id: "gucci-belt", name: "GG Marmont Belt", gender: "men", type: "accessories", sub: "Belts", brand: "Gucci",
    price: 450, best: true,
    img: "https://images.unsplash.com/photo-1624222247344-550fb60583fd?auto=format&fit=crop&w=1200&q=75",
    desc: "Leather belt with Double G buckle.",
    details: ["Leather", "Adjustable"], sizes: ["90","95","100","105"] },
  { id: "prada-wallet", name: "Saffiano Wallet", gender: "men", type: "accessories", sub: "Wallets", brand: "Prada",
    price: 420,
    img: "https://images.unsplash.com/photo-1627123424574-724758594e93?auto=format&fit=crop&w=1200&q=75",
    desc: "Compact bifold in signature Saffiano leather.",
    details: ["Saffiano leather", "Card slots"], sizes: ["ONE SIZE"] },
  { id: "lv-bag", name: "Keepall Bandoulière", gender: "men", type: "accessories", sub: "Bags", brand: "Louis Vuitton",
    price: 2100, isNew: true, badge: "NEW",
    img: "https://images.unsplash.com/photo-1548036328-c9fa89d128fa?auto=format&fit=crop&w=1200&q=75",
    desc: "Travel icon in monogram canvas with leather trim.",
    details: ["Monogram canvas", "Removable strap"], sizes: ["ONE SIZE"] },
  { id: "dior-sneaker", name: "B27 Sneaker", gender: "men", type: "shoes", sub: "Sneakers", brand: "Dior",
    price: 990, best: true,
    img: "https://images.unsplash.com/photo-1600185365483-26d7a4cc7519?auto=format&fit=crop&w=1200&q=75",
    desc: "Low-top sneaker with Oblique motif panels.",
    details: ["Leather & canvas", "Rubber sole"], sizes: ["40","41","42","43","44"] },
  { id: "fendi-tee", name: "FF Logo Tee", gender: "men", type: "clothing", sub: "T-Shirts", brand: "Fendi",
    price: 520,
    img: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?auto=format&fit=crop&w=1200&q=75",
    desc: "Soft cotton jersey with tonal FF logo.",
    details: ["Cotton jersey", "Regular fit"] }
];

/* derived fields — no need to edit */
(function () {
  var G = { men: "Men", women: "Women", unisex: "Unisex" };
  window.CATALOG.forEach(function (p) {
    p.sizes = p.sizes || (p.type === "accessories" ? ["ONE SIZE"] : ["XS", "S", "M", "L", "XL"]);
    p.cat = (p.brand ? p.brand + " · " : "") + G[p.gender] + " · " + p.sub;
    p.thumb = p.img.replace("w=1200", "w=600");
  });
})();

// Hide broken images gracefully (keeps gray placeholder)
  document.querySelectorAll('img').forEach(function (img) {
    img.addEventListener('error', function () { img.style.opacity = 0; });
  });
  // Close mobile menu when a link is tapped
  document.querySelectorAll('.mobile-menu a').forEach(function (a) {
    a.addEventListener('click', function () { document.getElementById('menu').checked = false; });
  });
  // Policy modals
  var policyReturn = '';
  function openPolicy(id) {
    document.querySelectorAll('dialog.policy[open]').forEach(function (d) { d.close(); });
    var d = document.getElementById(id); if (!d) return;
    if (!document.getElementById(location.hash.slice(1)) || location.hash.indexOf('#/') === 0) policyReturn = location.hash;
    d.showModal(); d.querySelector('.policy-body').scrollTop = 0;
    history.replaceState(null, '', '#' + id);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-policy]');
    if (t) { e.preventDefault(); openPolicy(t.getAttribute('data-policy')); }
  });
  document.querySelectorAll('dialog.policy').forEach(function (d) {
    d.querySelector('.policy-close').addEventListener('click', function () { d.close(); });
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    d.addEventListener('close', function () { history.replaceState(null, '', location.pathname + location.search + (policyReturn || '')); policyReturn = ''; });
  });
  var ph = location.hash.slice(1), pd = ph && document.getElementById(ph);
  if (pd && pd.matches('dialog.policy')) openPolicy(ph);
  // Next drop countdown — change this date (Paris time) for each drop
  var DROP_DATE = new Date('2026-10-31T18:00:00+01:00');
  (function () {
    var sec = document.getElementById('next-drop'); if (!sec) return;
    var el = function (id) { return document.getElementById(id); };
    el('drop-date').textContent = DROP_DATE.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }).toUpperCase()
      + ' — ' + DROP_DATE.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Paris' }) + ' (PARIS)';
    var pad = function (n) { return String(n).padStart(2, '0'); };
    function tick() {
      var diff = DROP_DATE - new Date();
      if (diff <= 0) {
        sec.classList.add('is-live'); el('drop-status').textContent = 'Live now';
        clearInterval(timer); return;
      }
      var t = Math.floor(diff / 1000);
      el('cd-d').textContent = pad(Math.floor(t / 86400));
      el('cd-h').textContent = pad(Math.floor(t % 86400 / 3600));
      el('cd-m').textContent = pad(Math.floor(t % 3600 / 60));
      el('cd-s').textContent = pad(t % 60);
    }
    var timer = setInterval(tick, 1000); tick();
    // Notify form — connect to your email tool (Shopify, Klaviyo, Mailchimp…) to actually collect addresses
    el('notify-form').addEventListener('submit', function (e) {
      e.preventDefault();
      el('notify-msg').textContent = "You're on the list. We'll email you when the drop goes live.";
      e.target.reset();
    });
  })();
  // ---------- Scratch card ----------
function makeScratch(canvas, opts) {
  var ctx = canvas.getContext('2d');
  var mask = document.createElement('canvas'), mctx = mask.getContext('2d');
  var w, h, dpr, drawing = false, last = null, started = false, done = false, pointer = { x: .5, y: .5 }, raf;
  var brush = opts.brush || 26;

  function resize() {
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    var r = canvas.getBoundingClientRect(); if (!r.width || !r.height) return; w = r.width; h = r.height;
    var old = null;
    if (mask.width) { old = document.createElement('canvas'); old.width = mask.width; old.height = mask.height; old.getContext('2d').drawImage(mask, 0, 0); }
    canvas.width = mask.width = Math.round(w * dpr); canvas.height = mask.height = Math.round(h * dpr);
    if (old) mctx.drawImage(old, 0, 0, mask.width, mask.height);
    render(performance.now());
  }
  function render(t) {
    if (!w || !h) return;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.globalCompositeOperation = 'source-over';
    ctx.clearRect(0, 0, w, h);
    opts.draw(ctx, w, h, t, pointer);
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.globalCompositeOperation = 'destination-out';
    ctx.drawImage(mask, 0, 0);
    ctx.globalCompositeOperation = 'source-over';
  }
  function loop(t) { render(t); raf = requestAnimationFrame(loop); }
  if (opts.animate) raf = requestAnimationFrame(loop);

  function pos(e) { var r = canvas.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
  function scratch(p) {
    mctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    mctx.lineCap = mctx.lineJoin = 'round'; mctx.lineWidth = brush * 2; mctx.strokeStyle = mctx.fillStyle = '#000';
    mctx.beginPath();
    if (last) { mctx.moveTo(last.x, last.y); mctx.lineTo(p.x, p.y); mctx.stroke(); }
    mctx.beginPath(); mctx.arc(p.x, p.y, brush, 0, Math.PI * 2); mctx.fill();
    last = p;
    if (!started) { started = true; opts.onStart && opts.onStart(); }
    if (!opts.animate) render();
  }
  function progress() {
    var d = mctx.getImageData(0, 0, mask.width, mask.height).data, step = 16, hit = 0, tot = 0;
    for (var i = 3; i < d.length; i += 4 * step) { tot++; if (d[i] > 0) hit++; }
    return hit / tot;
  }
  canvas.addEventListener('pointerdown', function (e) { if (done) return; drawing = true; last = null; canvas.setPointerCapture(e.pointerId); scratch(pos(e)); });
  canvas.addEventListener('pointermove', function (e) {
    var p = pos(e); pointer.x = p.x / w; pointer.y = p.y / h;
    if (drawing && !done) scratch(p);
  });
  function up() {
    if (!drawing) return; drawing = false; last = null;
    if (!done && progress() > (opts.threshold || .5)) { done = true; canvas.classList.add('done'); opts.onDone && opts.onDone(); }
  }
  canvas.addEventListener('pointerup', up); canvas.addEventListener('pointercancel', up);
  window.addEventListener('resize', resize);
  resize();
  return {
    setPointer: function (x, y) { pointer.x = x; pointer.y = y; },
    reset: function () { mctx.setTransform(1,0,0,1,0,0); mctx.clearRect(0, 0, mask.width, mask.height); done = started = false; canvas.classList.remove('done'); render(performance.now()); }
  };
}

/* ---------- Sealed package cover ---------- */
var noise = (function () {
  var c = document.createElement('canvas'); c.width = c.height = 140; var x = c.getContext('2d'), id = x.createImageData(140, 140);
  for (var i = 0; i < id.data.length; i += 4) { var v = Math.random() * 255; id.data[i] = id.data[i+1] = id.data[i+2] = v; id.data[i+3] = 14; }
  x.putImageData(id, 0, 0); return c;
})();
function drawTape(ctx, len, th, text, dark) {
  ctx.save(); ctx.shadowColor = 'rgba(0,0,0,.25)'; ctx.shadowBlur = 10; ctx.shadowOffsetY = 3;
  ctx.fillStyle = dark ? '#0A0A0A' : '#F7F7F7';
  ctx.fillRect(-len / 2, -th / 2, len, th); ctx.restore();
  ctx.fillStyle = dark ? 'rgba(255,255,255,.08)' : 'rgba(0,0,0,.08)';
  ctx.fillRect(-len / 2, -th / 2, len, 2); ctx.fillRect(-len / 2, th / 2 - 2, len, 2);
  ctx.fillStyle = dark ? '#F2F2F2' : '#0A0A0A';
  ctx.font = '800 ' + Math.round(th * .36) + 'px Inter, Arial, sans-serif';
  ctx.textBaseline = 'middle';
  var unit = text + '     ', uw = ctx.measureText(unit).width;
  for (var x = -len / 2; x < len / 2; x += uw) ctx.fillText(unit, x, 1);
}
function drawPackage(ctx, w, h, t, p) {
  holoFoil(ctx, w, h, t, p, 9);
  ctx.fillStyle = ctx.createPattern(noise, 'repeat'); ctx.fillRect(0, 0, w, h);
  ctx.strokeStyle = 'rgba(40,40,60,.18)'; ctx.lineWidth = 1;
  ctx.beginPath(); ctx.moveTo(w / 2, 0); ctx.lineTo(w / 2, h); ctx.moveTo(0, h / 2); ctx.lineTo(w, h / 2); ctx.stroke();
  var len = Math.hypot(w, h) * 1.2;
  ctx.save(); ctx.translate(w / 2, h * .3); ctx.rotate(-.35); drawTape(ctx, len, 46, 'LEKOINDULUXE — DO NOT OPEN —', false); ctx.restore();
  ctx.save(); ctx.translate(w / 2, h * .72); ctx.rotate(-.35); drawTape(ctx, len, 46, 'SEALED — LIMITED DROP — SEALED —', false); ctx.restore();
  ctx.save(); ctx.translate(w / 2, h / 2); ctx.rotate(.5); drawTape(ctx, len, 36, 'LEKOINDULUXE ✦ AUTHENTIC ✦', true); ctx.restore();
  // shipping label
  var lw = Math.min(190, w * .46), lh = 92, lx = w - lw - 22, ly = 22;
  ctx.save(); ctx.translate(lx + lw / 2, ly + lh / 2); ctx.rotate(.04);
  ctx.shadowColor = 'rgba(0,0,0,.2)'; ctx.shadowBlur = 10; ctx.shadowOffsetY = 3;
  ctx.fillStyle = '#F7F7F7'; ctx.fillRect(-lw / 2, -lh / 2, lw, lh); ctx.shadowColor = 'transparent';
  ctx.fillStyle = '#0A0A0A'; ctx.font = '800 10px Inter, Arial'; ctx.textBaseline = 'top';
  ctx.fillText('FRAGILE — HANDLE WITH STYLE', -lw / 2 + 12, -lh / 2 + 12);
  ctx.font = '900 20px Inter, Arial'; ctx.fillText('FOR: YOU', -lw / 2 + 12, -lh / 2 + 30);
  for (var i = 0; i < 26; i++) { var bw = (i * 7 % 3) + 1; ctx.fillRect(-lw / 2 + 12 + i * 6, lh / 2 - 26, bw, 16); }
  ctx.restore();
}

/* ---------- Hologram foil ---------- */
function holoFoil(ctx, w, h, t, p, textSize) {
  textSize = textSize || 8;
  var shift = (p.x * 1.2 + p.y * .6 + t / 6000) % 1;
  var g = ctx.createLinearGradient(-w * .5 + shift * w * 2 - w, 0, w * 1.5 + shift * w * 2 - w, h);
  var cols = ['#d9d9e8', '#f7c9e8', '#c9e7f7', '#d4f7d9', '#f7f1c9', '#e2c9f7', '#c9f2f7', '#d9d9e8'];
  cols.forEach(function (c, i) { g.addColorStop(i / (cols.length - 1), c); });
  ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
  // metallic base
  var m = ctx.createLinearGradient(0, 0, 0, h); m.addColorStop(0, 'rgba(255,255,255,.35)'); m.addColorStop(.5, 'rgba(120,120,140,.25)'); m.addColorStop(1, 'rgba(255,255,255,.3)');
  ctx.fillStyle = m; ctx.fillRect(0, 0, w, h);
  // diffraction lines
  ctx.save(); ctx.globalAlpha = .18; ctx.strokeStyle = '#fff'; ctx.lineWidth = 1;
  for (var x = -h; x < w + h; x += 5) { ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x + h, h); ctx.stroke(); }
  ctx.restore();
  // micro-text pattern
  ctx.save(); ctx.globalAlpha = .22; ctx.fillStyle = '#3a3a55'; ctx.font = '700 ' + textSize + 'px Inter, Arial'; ctx.textBaseline = 'top';
  var mt = 'AUTHENTIC ✦ LEKOINDULUXE ✦ ', mw = ctx.measureText(mt).width;
  for (var y = 4, r = 0; y < h; y += textSize * 1.75, r++) for (var mx0 = (r % 2) * -30; mx0 < w; mx0 += mw) ctx.fillText(mt, mx0, y);
  ctx.restore();
  // moving glare
  var gx = p.x * w, gl = ctx.createRadialGradient(gx, h * p.y, 0, gx, h * p.y, w * .45);
  gl.addColorStop(0, 'rgba(255,255,255,.65)'); gl.addColorStop(1, 'rgba(255,255,255,0)');
  ctx.fillStyle = gl; ctx.fillRect(0, 0, w, h);
}
  (function () {
    var pkg = document.getElementById('pkg'); if (!pkg) return;
    var hint = pkg.querySelector('.pkg-hint'), copy = pkg.querySelector('.pkg-copy');
    var start = function () {
      makeScratch(pkg.querySelector('canvas'), {
        draw: drawPackage, animate: true, brush: 28,
        onStart: function () { hint.classList.add('hide'); },
        onDone: function () { copy.classList.add('show'); }
      });
    };
    (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(start);
    pkg.addEventListener('pointermove', function (e) {
      var r = pkg.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      pkg.style.transform = 'rotateY(' + ((x - .5) * 6) + 'deg) rotateX(' + ((.5 - y) * 6) + 'deg)';
    });
    pkg.addEventListener('pointerleave', function () { pkg.style.transform = ''; });
    copy.addEventListener('click', function () {
      var code = copy.getAttribute('data-code');
      var fallback = function () { var t = document.createElement('textarea'); t.value = code; document.body.appendChild(t); t.select(); document.execCommand('copy'); t.remove(); };
      (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).catch(fallback)
        .finally(function () { copy.textContent = 'COPIED ✓'; });
    });
  })();
  // ---------- Cart ----------
  (function () {
var PRODUCTS = window.CATALOG;
var FREE_SHIP = 99, SHIP_COST = 7.9, CODE = 'WELCOME10';
var SIZES = ['XS', 'S', 'M', 'L', 'XL'];
var state = { items: [], promo: false, gift: false, giftMsg: '', removed: null };
var $ = function (id) { return document.getElementById(id); };
var byId = function (id) { return PRODUCTS.filter(function (p) { return p.id === id; })[0]; };
var money = function (n) { return '$' + (Math.round(n * 100) / 100).toFixed(n % 1 ? 2 : 0); };

function add(id, size) {
  var ex = state.items.filter(function (i) { return i.id === id && i.size === (size || 'M'); })[0];
  if (ex) ex.qty++; else state.items.push({ id: id, size: size || 'M', qty: 1 });
  state.removed = null; render(); open();
  var c = $('open-cart'); c.classList.remove('cart-bump'); void c.offsetWidth; c.classList.add('cart-bump');
}
function totals() {
  var sub = state.items.reduce(function (s, i) { return s + byId(i.id).price * i.qty; }, 0);
  var disc = state.promo ? sub * 0.10 : 0, after = sub - disc;
  var ship = sub === 0 ? 0 : (after >= FREE_SHIP ? 0 : SHIP_COST);
  return { sub: sub, disc: disc, after: after, ship: ship, total: after + ship, count: state.items.reduce(function (s, i) { return s + i.qty; }, 0) };
}
function miniCard(p) {
  return '<div class="mini"><div class="t"><img src="' + p.thumb + '" alt="" onerror="this.style.opacity=0"></div><div><b>' + p.name + '</b><span>$' + p.price + '</span><br><button data-add="' + p.id + '">+ ADD</button></div></div>';
}
function render() {
  var t = totals();
  $('cart-count').textContent = t.count;
  $('d-title').textContent = 'YOUR BAG (' + t.count + ')';
  var html = '';
  if (!state.items.length) {
    var best = [byId('jacket'), byId('hoodie')];
    html = '<div class="d-body"><div class="empty">' +
      '<div class="big">NOTHING<br>HERE YET</div><p>Your bag is empty — but the next drop isn\'t far.</p>' +
      '<h5>NEXT DROP IN</h5><div class="cd"><div><b id="e-d">00</b><span>DAYS</span></div><div><b id="e-h">00</b><span>HRS</span></div><div><b id="e-m">00</b><span>MIN</span></div><div><b id="e-s">00</b><span>SEC</span></div></div>' +
      '<h5>BEST SELLERS</h5><div class="look-row">' + best.map(miniCard).join('') + '</div>' +
      '<button class="checkout" id="keep-shopping">SHOP NOW →</button>' +
      (state.removed ? '' : '') + '</div></div>';
    $('d-content').innerHTML = html; tickEmpty(); bind(); return;
  }
  var left = FREE_SHIP - t.after, pct = Math.min(100, t.after / FREE_SHIP * 100);
  html += '<div class="ship' + (left <= 0 ? ' done' : '') + '"><p>' + (left <= 0 ? '✦ FREE DELIVERY UNLOCKED ✦' : 'YOU\'RE <b>' + money(left) + '</b> AWAY FROM FREE DELIVERY') + '</p><div class="bar"><i style="width:' + pct + '%"></i></div></div>';
  html += '<div class="d-body">';
  if (state.removed) html += '<div class="undo"><span>' + byId(state.removed.item.id).name + ' removed</span><button id="undo">UNDO</button></div>';
  html += '<div class="items">' + state.items.map(function (i, idx) {
    var p = byId(i.id), line = p.price * i.qty;
    return '<div class="item"><div class="thumb"><img src="' + p.thumb + '" alt="" onerror="this.style.opacity=0"></div>' +
      '<div><h4>' + p.name + '</h4><div class="cat">' + p.cat + '</div><div class="opts">' +
      '<select class="size" data-size="' + idx + '" aria-label="Size">' + (p.sizes || SIZES).map(function (s) { return '<option' + (s === i.size ? ' selected' : '') + '>' + s + '</option>'; }).join('') + '</select>' +
      '<div class="qty"><button data-dec="' + idx + '" aria-label="Less">−</button><span>' + i.qty + '</span><button data-inc="' + idx + '" aria-label="More">+</button></div></div></div>' +
      '<div class="right"><div class="price">' + (state.promo ? '<s>' + money(line) + '</s>' + money(line * .9) : money(line)) + '</div><button class="rm" data-rm="' + idx + '">REMOVE</button></div></div>';
  }).join('') + '</div>';
  html += '<div class="auth-line"><span class="holo-dot"></span>100% AUTHENTIC — EVERY PIECE VERIFIED</div>';
  var sugg = PRODUCTS.filter(function (p) { return !state.items.some(function (i) { return i.id === p.id; }); }).slice(0, 2);
  if (sugg.length) html += '<div class="look"><h5>COMPLETE THE LOOK</h5><div class="look-row">' + sugg.map(miniCard).join('') + '</div></div>';
  html += '</div><div class="d-foot">';
  html += state.promo
    ? '<div class="promo applied"><span>✓ <b>' + CODE + '</b> applied — you save ' + money(t.disc) + '</span><button id="promo-off">REMOVE</button></div>'
    : '<div class="promo"><span>🎁 Your gift: <b>' + CODE + '</b> — 10% off</span><button id="promo-on">APPLY</button></div>';
  html += '<label class="gift"><input type="checkbox" id="gift"' + (state.gift ? ' checked' : '') + '> This is a gift — add a message &amp; hide prices</label>' +
    '<textarea class="gift-msg' + (state.gift ? ' show' : '') + '" id="gift-msg" placeholder="Your gift message…">' + state.giftMsg + '</textarea>';
  html += '<div class="totals"><div><span>Subtotal</span><span>' + money(t.sub) + '</span></div>' +
    (state.promo ? '<div class="disc"><span>Discount (' + CODE + ')</span><span>−' + money(t.disc) + '</span></div>' : '') +
    '<div><span>Delivery</span><span>' + (t.ship ? money(t.ship) : 'FREE') + '</span></div>' +
    '<div class="grand"><span>TOTAL</span><span>' + money(t.total) + '</span></div></div>';
  html += '<button class="checkout" id="checkout">CHECKOUT — ' + money(t.total) + ' <span>→</span></button>';
  html += '<div class="trust"><span>🔒 SECURE PAYMENT</span><span>↺ 30-DAY RETURNS</span><span>✦ 100% AUTHENTIC</span></div></div>';
  $('d-content').innerHTML = html; bind();
}
function bind() {
  var c = $('d-content');
  c.querySelectorAll('[data-add]').forEach(function (b) { b.onclick = function () { add(b.dataset.add); toast('Added to bag'); }; });
  c.querySelectorAll('[data-inc]').forEach(function (b) { b.onclick = function () { state.items[b.dataset.inc].qty++; render(); }; });
  c.querySelectorAll('[data-dec]').forEach(function (b) { b.onclick = function () { var i = state.items[b.dataset.dec]; if (i.qty > 1) { i.qty--; render(); } else removeAt(+b.dataset.dec); }; });
  c.querySelectorAll('[data-rm]').forEach(function (b) { b.onclick = function () { removeAt(+b.dataset.rm); }; });
  c.querySelectorAll('[data-size]').forEach(function (s) { s.onchange = function () { state.items[s.dataset.size].size = s.value; toast('Size changed to ' + s.value); }; });
  if ($('undo')) $('undo').onclick = function () { state.items.splice(state.removed.idx, 0, state.removed.item); state.removed = null; render(); };
  if ($('promo-on')) $('promo-on').onclick = function () { state.promo = true; render(); toast('WELCOME10 applied — 10% off'); };
  if ($('promo-off')) $('promo-off').onclick = function () { state.promo = false; render(); };
  if ($('gift')) $('gift').onchange = function (e) { state.gift = e.target.checked; $('gift-msg').classList.toggle('show', state.gift); };
  if ($('gift-msg')) $('gift-msg').oninput = function (e) { state.giftMsg = e.target.value; };
  if ($('checkout')) $('checkout').onclick = function () { toast('Checkout will open here once the store is connected to Shopify'); };
  if ($('keep-shopping')) $('keep-shopping').onclick = function () { close(); location.hash = '#/shop'; };
}
var undoTimer;
function removeAt(idx) {
  state.removed = { idx: idx, item: state.items.splice(idx, 1)[0] };
  render();
  clearTimeout(undoTimer);
  undoTimer = setTimeout(function () { if (state.removed) { state.removed = null; render(); } }, 5000);
}
var emptyTimer;
function tickEmpty() {
  clearInterval(emptyTimer);
  var pad = function (n) { return String(n).padStart(2, '0'); };
  function f() {
    if (!$('e-d')) return clearInterval(emptyTimer);
    var s = Math.max(0, Math.floor((DROP_DATE - new Date()) / 1000));
    $('e-d').textContent = pad(Math.floor(s / 86400)); $('e-h').textContent = pad(Math.floor(s % 86400 / 3600));
    $('e-m').textContent = pad(Math.floor(s % 3600 / 60)); $('e-s').textContent = pad(s % 60);
  }
  f(); emptyTimer = setInterval(f, 1000);
}
function open() { document.body.classList.add('cart-open'); $('drawer').classList.add('open'); $('cart-overlay').classList.add('open'); $('drawer').setAttribute('aria-hidden', 'false'); }
function close() { document.body.classList.remove('cart-open'); $('drawer').classList.remove('open'); $('cart-overlay').classList.remove('open'); $('drawer').setAttribute('aria-hidden', 'true'); }
var tt;
function toast(msg) { var t = $('cart-toast'); t.textContent = msg; t.classList.add('show'); clearTimeout(tt); tt = setTimeout(function () { t.classList.remove('show'); }, 2200); }


$('open-cart').onclick = function (e) { e.preventDefault(); open(); };
$('close-cart').onclick = close; $('cart-overlay').onclick = close;
document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
window.LKCart = { add: add, open: open, close: close, toast: toast };
render();
  })();

/* ============================================================
   REVIEWS — the only place you need to edit.
   Add one { } per real review, newest first. Example:
   { name: "Sarah K.", city: "Paris", product: "Leather tote",
     rating: 5, date: "2026-10-14", verified: true,
     text: "Beautiful bag, arrived beautifully wrapped." },
   Leave the list empty to show the "first reviews" block.
   ============================================================ */
var REVIEWS = [
];
var REVIEW_EMAIL = window.SITE.email;       // set in SITE settings
var INSTAGRAM_URL = window.SITE.instagram;  // set in SITE settings
var REVIEWS_PER_PAGE = 3;

(function () {
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5l2.9 6.2 6.8.8-5 4.7 1.3 6.7L12 17.6l-6 3.3 1.3-6.7-5-4.7 6.8-.8z"/></svg>';
  var FIVE = STAR + STAR + STAR + STAR + STAR;
  var LABELS = ['', 'Poor', 'Fair', 'Good', 'Very good', 'Excellent'];
  function $(id) { return document.getElementById(id); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function rating(r, big) {
    var pct = Math.max(0, Math.min(5, r)) / 5 * 100;
    return '<span class="rating" role="img" aria-label="' + (Math.round(r * 10) / 10) + ' out of 5 stars"' + (big ? ' style="transform:scale(1.15);transform-origin:left"' : '') + '>' +
      '<span class="stars base">' + FIVE + '</span><span class="fill" style="width:' + pct + '%"><span class="stars">' + FIVE + '</span></span></span>';
  }
  function initials(n) { return String(n || '?').trim().split(/\s+/).map(function (w) { return w.charAt(0); }).join('').slice(0, 2).toUpperCase(); }
  function fmtDate(d) {
    if (!d) return '';
    var t = new Date(d); if (isNaN(t)) return esc(d);
    return t.toLocaleDateString('en-GB', { month: 'short', year: 'numeric' });
  }

  var list = REVIEWS.filter(function (r) { return r && r.text && r.rating; })
    .sort(function (a, b) { return String(b.date || '').localeCompare(String(a.date || '')); });
  var shown = 0;

  function card(r) {
    var sub = [r.city, r.product].filter(Boolean).map(esc).join(' · ');
    return '<article class="rev-card">' +
      '<div class="rev-top">' + rating(r.rating) + '<span>' + fmtDate(r.date) + '</span></div>' +
      '<blockquote>' + esc(r.text) + '</blockquote>' +
      '<div class="rev-author"><div class="rev-avatar" aria-hidden="true">' + esc(initials(r.name)) + '</div>' +
      '<div><strong>' + esc(r.name) + '</strong>' + (sub ? '<span>' + sub + '</span>' : '') + '</div>' +
      (r.verified ? '<span class="verified">VERIFIED BUYER</span>' : '') + '</div></article>';
  }
  function showMore() {
    var next = list.slice(shown, shown + REVIEWS_PER_PAGE);
    $('rev-grid').insertAdjacentHTML('beforeend', next.map(card).join(''));
    shown += next.length;
    $('rev-more').hidden = shown >= list.length;
  }

  if (list.length) {
    var avg = list.reduce(function (s, r) { return s + Number(r.rating); }, 0) / list.length;
    $('rev-summary').innerHTML = '<span class="score">' + avg.toFixed(1) + '</span><div>' + rating(avg, true) +
      '<div style="margin-top:8px">BASED ON ' + list.length + ' REVIEW' + (list.length > 1 ? 'S' : '') + '</div></div>';
    $('rev-summary').hidden = false;
    $('rev-grid').hidden = false;
    $('rev-actions').hidden = false;
    showMore();
    $('rev-more').addEventListener('click', showMore);
  } else {
    $('rev-empty').hidden = false;
  }
  if (INSTAGRAM_URL) { $('rev-insta').href = INSTAGRAM_URL; $('rev-insta').target = '_blank'; $('rev-insta').rel = 'noopener'; } else $('rev-insta').hidden = true;

  /* Star picker */
  var picked = 0, pick = $('star-pick'), html = '';
  for (var i = 1; i <= 5; i++) {
    html += '<input type="radio" name="rv-rating" id="rv-s' + i + '" value="' + i + '"><label for="rv-s' + i + '" data-v="' + i + '" title="' + LABELS[i] + '"><span class="sr-only" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)">' + i + ' star' + (i > 1 ? 's' : '') + '</span>' + STAR + '</label>';
  }
  pick.innerHTML = html;
  var labels = pick.querySelectorAll('label');
  function paint(n) { labels.forEach(function (l) { l.classList.toggle('on', +l.dataset.v <= n); }); $('star-pick-text').textContent = n ? LABELS[n].toUpperCase() : 'Choose 1 to 5 stars'; }
  labels.forEach(function (l) {
    l.addEventListener('mouseenter', function () { paint(+l.dataset.v); });
    l.addEventListener('mouseleave', function () { paint(picked); });
  });
  pick.addEventListener('change', function (e) { picked = +e.target.value; paint(picked); });

  /* Open / close / send */
  var form = $('rev-form');
  function open() { form.hidden = false; $('rev-thanks').hidden = true; form.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { $('rv-s1').focus({ preventScroll: true }); }, 400); }
  document.querySelectorAll('.js-open-review').forEach(function (b) { b.addEventListener('click', open); });
  $('rev-cancel').addEventListener('click', function () { form.hidden = true; });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var name = $('rv-name').value.trim(), text = $('rv-text').value.trim();
    var err = !picked ? 'Please choose a star rating.' : !name ? 'Please add your first name.' : text.length < 10 ? 'Please write a few words about your purchase.' : '';
    $('rev-err').textContent = err;
    if (err) return;
    var body = 'Rating: ' + picked + '/5\nName: ' + name + '\nCity: ' + $('rv-city').value.trim() +
      '\nProduct: ' + $('rv-product').value.trim() + '\nOrder: ' + $('rv-order').value.trim() + '\n\n' + text;
    window.location.href = 'mailto:' + REVIEW_EMAIL + '?subject=' + encodeURIComponent('New review — ' + picked + '/5 from ' + name) + '&body=' + encodeURIComponent(body);
    form.reset(); picked = 0; paint(0);
    form.hidden = true; $('rev-thanks').hidden = false;
  });
})();

/* ============================================================
   PAGES — shop, product, search, wishlist, track order, help, app.
   Pages are built from CATALOG and MENU above; no need to edit here.
   ============================================================ */
(function () {
  var M = window.MENU, S = window.SITE, womenSoon = !S.womenLive;
  var C = window.CATALOG.filter(function (p) { return !(womenSoon && p.gender === 'women'); });
  if (womenSoon) document.body.classList.add('women-soon');
  var main = document.querySelector('main'), view = document.getElementById('view'), header = document.querySelector('.header');
  var HOME_TITLE = document.title;
  var HEART = '<svg viewBox="0 0 24 24"><path d="M12 21s-7.5-4.6-9.5-9.3C1 8.2 3.3 4.5 7 4.5c2.1 0 3.6 1.1 5 3 1.4-1.9 2.9-3 5-3 3.7 0 6 3.7 4.5 7.2C19.5 16.4 12 21 12 21z"/></svg>';
  var ARROW = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var SEC = { new: 'New in', best: 'Best sellers', sale: 'Sale', clothing: 'Clothing', shoes: 'Shoes', accessories: 'Accessories', brands: 'Brands' };
  var GEN = { all: 'All', men: 'Men', women: 'Women' };
  var BRANDS = window.BRANDS || [];

  function byId(id) { return C.filter(function (p) { return p.id === id; })[0]; }
  function slug(s) { return String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/&/g, ' ').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(n) { return '$' + (n % 1 ? n.toFixed(2) : n); }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function toast(m) { window.LKCart ? window.LKCart.toast(m) : null; }
  function crumbs(list) {
    return '<nav class="crumbs" aria-label="Breadcrumb">' + list.map(function (c, i) {
      return (i ? '<span aria-hidden="true">/</span>' : '') + (c[1] ? '<a href="' + c[1] + '">' + esc(c[0]) + '</a>' : '<span>' + esc(c[0]) + '</span>');
    }).join('') + '</nav>';
  }
  function dropText() {
    if (typeof DROP_DATE === 'undefined' || DROP_DATE < new Date()) return '';
    return DROP_DATE.toLocaleDateString('en-GB', { day: 'numeric', month: 'long' });
  }

  /* ---------- Wishlist (saved in this browser) ---------- */
  var WKEY = 'lekoindulux-wishlist', wish = [];
  try { wish = JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) {}
  wish = wish.filter(byId);
  function saveWish() { try { localStorage.setItem(WKEY, JSON.stringify(wish)); } catch (e) {} syncWish(); }
  function isWished(id) { return wish.indexOf(id) > -1; }
  function toggleWish(id) {
    var p = byId(id); if (!p) return;
    if (isWished(id)) { wish.splice(wish.indexOf(id), 1); toast('Removed from wishlist'); }
    else { wish.push(id); toast('Saved to wishlist ♥'); }
    saveWish();
    if (current === 'wishlist') route();
  }
  function syncWish() {
    document.querySelectorAll('[data-wish]').forEach(function (b) {
      var on = isWished(b.getAttribute('data-wish'));
      b.classList.toggle('active', on); b.setAttribute('aria-pressed', on);
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
    document.querySelectorAll('.js-wish-count').forEach(function (el) { el.textContent = wish.length ? '(' + wish.length + ')' : ''; });
  }

  /* ---------- Product card ---------- */
  function card(p) {
    return '<article class="prod-card"><div class="prod-img">' +
      (p.badge ? '<span class="badge">' + esc(p.badge) + '</span>' : '') +
      '<button class="wish" data-wish="' + p.id + '" aria-label="Add to wishlist" aria-pressed="false">' + HEART + '</button>' +
      '<a class="prod-link" href="#/product/' + p.id + '" tabindex="-1" aria-hidden="true"><img src="' + p.thumb + '" alt="' + esc(p.name) + '" loading="lazy" onerror="this.style.opacity=0"></a>' +
      '<button class="quick-add" data-quick="' + p.id + '">+ ADD TO BAG</button></div>' +
      '<div class="prod-meta"><div><h3><a href="#/product/' + p.id + '">' + esc(p.name) + '</a></h3><p class="cat">' + esc(p.cat) + '</p></div>' +
      '<p class="price">' + (p.was ? '<s>' + money(p.was) + '</s>' : '') + money(p.price) + '</p></div></article>';
  }
  function grid(list) { return '<div class="prod-grid">' + list.map(card).join('') + '</div>'; }
  function defaultSize(p) { return p.sizes.indexOf('M') > -1 ? 'M' : p.sizes[0]; }

  /* ---------- Shop ---------- */
  function subsFor(g, sec) {
    var out = [];
    (g === 'all' ? ['men', 'women'] : [g]).forEach(function (k) { (M[k][sec] || []).forEach(function (s) { if (out.indexOf(s) < 0) out.push(s); }); });
    C.forEach(function (p) { if (p.type === sec && (g === 'all' || p.gender === g || p.gender === 'unisex') && out.indexOf(p.sub) < 0) out.push(p.sub); });
    return out;
  }
  function brandsFor(g) {
    var out = [];
    BRANDS.forEach(function (b) { out.push(b); });
    C.forEach(function (p) {
      if (p.brand && (g === 'all' || p.gender === g || p.gender === 'unisex') && out.indexOf(p.brand) < 0) out.push(p.brand);
    });
    return out;
  }
  function shopHref(g, sec, sub, sort) {
    var h = '#/shop/' + (g || 'all') + (sec ? '/' + sec : '') + (sub ? '/' + sub : '');
    return h + (sort && sort !== 'featured' ? '?sort=' + sort : '');
  }
  function shopPage(parts, q) {
    var g = parts[0] || 'all', sec = parts[1] || '', sub = parts[2] || '', sort = q.get('sort') || 'featured';
    if (g === 'women' && womenSoon) return womenPage();
    if (!GEN[g] || (sec && !SEC[sec])) return notFound();
    var list = C.filter(function (p) { return g === 'all' || p.gender === g || p.gender === 'unisex'; });
    if (sec && sec !== 'brands') list = list.filter(function (p) { return sec === 'new' ? p.isNew : sec === 'best' ? p.best : sec === 'sale' ? !!p.was : p.type === sec; });
    var subName = '';
    if (sub) {
      if (sec === 'brands') {
        subName = (brandsFor(g).filter(function (b) { return slug(b) === sub; })[0]) || sub.replace(/-/g, ' ');
        list = list.filter(function (p) { return p.brand && slug(p.brand) === sub; });
      } else {
        subName = (subsFor(g, sec).filter(function (s) { return slug(s) === sub; })[0]) || sub.replace(/-/g, ' ');
        list = list.filter(function (p) { return slug(p.sub) === sub; });
      }
    }
    var sorted = list.slice();
    if (sort === 'price-asc') sorted.sort(function (a, b) { return a.price - b.price; });
    if (sort === 'price-desc') sorted.sort(function (a, b) { return b.price - a.price; });
    if (sort === 'new') sorted.sort(function (a, b) { return (b.isNew ? 1 : 0) - (a.isNew ? 1 : 0); });
    if (sort === 'brand') sorted.sort(function (a, b) { return String(a.brand || '').localeCompare(String(b.brand || '')); });

    var title = subName || SEC[sec] || (g !== 'all' ? GEN[g] : 'Shop all');
    var cr = [['Home', '#/'], ['Shop', g === 'all' && !sec ? '' : '#/shop']];
    if (g !== 'all') cr.push([GEN[g], sec ? shopHref(g) : '']);
    if (sec) cr.push([SEC[sec], sub ? shopHref(g, sec) : '']);
    if (sub) cr.push([subName, '']);

    var genChips = ['all', 'men', 'women'].map(function (k) { return '<a class="chip' + (k === g ? ' on' : '') + '" href="' + shopHref(k, sec, '', sort) + '">' + GEN[k] + '</a>'; }).join('');
    var secList = ['new', 'best', 'clothing', 'shoes', 'accessories', 'brands', 'sale'];
    var secChips = '<a class="chip' + (!sec ? ' on' : '') + '" href="' + shopHref(g, '', '', sort) + '">Everything</a>' +
      secList.map(function (k) {
        return '<a class="chip' + (k === 'sale' ? ' sale' : '') + (k === sec ? ' on' : '') + '" href="' + shopHref(g, k, '', sort) + '">' + SEC[k] + '</a>';
      }).join('');
    var subChips = '';
    if (sec === 'clothing' || sec === 'shoes' || sec === 'accessories') {
      subChips = '<div class="chips small"><a class="chip' + (!sub ? ' on' : '') + '" href="' + shopHref(g, sec, '', sort) + '">All ' + SEC[sec] + '</a>' +
        subsFor(g, sec).map(function (s) { return '<a class="chip' + (slug(s) === sub ? ' on' : '') + '" href="' + shopHref(g, sec, slug(s), sort) + '">' + esc(s) + '</a>'; }).join('') + '</div>';
    }
    if (sec === 'brands' || (g === 'men' && !sec)) {
      var brandList = brandsFor(g === 'all' ? 'men' : g);
      subChips += '<div class="chips small"><span class="chip" style="pointer-events:none;opacity:.55;border-style:dashed">BRANDS</span>' +
        (sec === 'brands' ? '<a class="chip' + (!sub ? ' on' : '') + '" href="' + shopHref(g, 'brands', '', sort) + '">All brands</a>' : '') +
        brandList.map(function (b) {
          var on = sec === 'brands' && slug(b) === sub;
          return '<a class="chip' + (on ? ' on' : '') + '" href="' + shopHref(g, 'brands', slug(b), sort) + '">' + esc(b) + '</a>';
        }).join('') + '</div>';
    }
    var sortSel = '<label class="sort">SORT <select id="sort">' +
      [['featured', 'Featured'], ['new', 'Newest'], ['brand', 'Brand A–Z'], ['price-asc', 'Price: low to high'], ['price-desc', 'Price: high to low']].map(function (o) {
        return '<option value="' + o[0] + '"' + (o[0] === sort ? ' selected' : '') + '>' + o[1] + '</option>';
      }).join('') + '</select></label>';

    var d = dropText();
    var body = sorted.length ? grid(sorted) :
      '<div class="empty-state"><div class="kicker">COMING SOON</div><h2>' + esc(title) + '<br>lands soon.</h2>' +
      '<p>' + (d ? 'New pieces arrive with the next drop on ' + d + '. ' : 'New pieces are on their way. ') + 'Get notified and be first in line.</p>' +
      '<div class="btn-row"><a class="btn" href="#next-drop">Notify me ' + ARROW + '</a><a class="btn btn-line" href="#/shop">Shop all</a></div></div>';

    return {
      title: (g !== 'all' && sec ? GEN[g] + ' — ' : '') + title,
      html: '<div class="wrap page">' + crumbs(cr) +
        '<div class="page-head"><div>' + (g !== 'all' && sec ? '<p class="eyebrow">' + GEN[g] + '</p>' : '') + '<h1 class="page-title">' + esc(title) + '</h1></div>' +
        '<span class="page-count">' + sorted.length + ' PIECE' + (sorted.length === 1 ? '' : 'S') + '</span></div>' +
        '<div class="toolbar"><div class="toolbar-row"><div class="chips">' + genChips + '</div>' + sortSel + '</div><div class="chips">' + secChips + '</div>' + subChips + '</div>' +
        body + '</div>',
      after: function () {
        document.getElementById('sort').onchange = function (e) { location.hash = shopHref(g, sec, sub, e.target.value); };
      }
    };
  }

  /* ---------- Product ---------- */
  function productPage(id) {
    var p = byId(id);
    if (!p && womenSoon && window.CATALOG.some(function (x) { return x.id === id && x.gender === 'women'; })) return womenPage();
    if (!p) return notFound();
    var one = p.sizes.length === 1, size = one ? p.sizes[0] : '';
    var related = C.filter(function (x) { return x.id !== p.id; })
      .sort(function (a, b) { return (b.type === p.type) - (a.type === p.type); }).slice(0, 4);
    var gLink = p.gender === 'unisex' ? 'all' : p.gender;
    return {
      title: p.name,
      html: '<div class="wrap page">' + crumbs([['Home', '#/'], ['Shop', '#/shop'], [p.gender === 'unisex' ? 'Unisex' : GEN[p.gender], shopHref(gLink)]].concat(p.brand ? [[p.brand, shopHref(gLink === 'all' ? 'men' : gLink, 'brands', slug(p.brand))]] : []).concat([[p.sub, shopHref(gLink, p.type, slug(p.sub))], [p.name, '']])) +
        '<div class="pdp"><div class="pdp-img">' + (p.badge ? '<span class="badge">' + esc(p.badge) + '</span>' : '') + '<img src="' + p.img + '" alt="' + esc(p.name) + '" onerror="this.style.opacity=0"></div>' +
        '<div class="pdp-info"><p class="eyebrow">' + esc(p.cat) + '</p><h1>' + esc(p.name) + '</h1>' +
        '<p class="pdp-price">' + (p.was ? '<s>' + money(p.was) + '</s>' : '') + money(p.price) + '</p><p class="pdp-note">Taxes included. Delivery calculated at checkout.</p>' +
        '<p class="pdp-desc">' + esc(p.desc || '') + '</p>' +
        '<div class="pdp-label"><span>Size' + (size ? ': ' + size : '') + '</span>' + (one ? '' : '<a href="#/help/sizing">Size help</a>') + '</div>' +
        '<div class="sizes" role="radiogroup" aria-label="Size">' + p.sizes.map(function (s) {
          return '<button type="button" class="size-btn' + (s === size ? ' on' : '') + '" role="radio" aria-checked="' + (s === size) + '" data-size="' + esc(s) + '">' + esc(s) + '</button>';
        }).join('') + '</div><p class="pdp-err" id="pdp-err" role="alert"></p>' +
        '<div class="pdp-actions"><button class="btn" id="pdp-add">Add to bag ' + ARROW + '</button><button class="wish-lg" data-wish="' + p.id + '" aria-label="Add to wishlist" aria-pressed="false">' + HEART + '</button></div>' +
        '<div class="pdp-trust"><span>✦ 100% AUTHENTIC</span><span>↺ 30-DAY RETURNS</span><span>🔒 SECURE PAYMENT</span></div>' +
        '<div class="acc">' +
        (p.details && p.details.length ? '<details open><summary>Details</summary><div class="acc-body"><ul>' + p.details.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul></div></details>' : '') +
        '<details><summary>Delivery</summary><div class="acc-body">Free delivery on orders above $99. You\'ll get a tracking number by email as soon as your order ships. <button class="link" data-policy="shipping-policy">Shipping Policy</button></div></details>' +
        '<details><summary>Returns</summary><div class="acc-body">30 days to return unworn items with their tags. <button class="link" data-policy="refund-policy">Refund Policy</button></div></details>' +
        '<details><summary>Authenticity</summary><div class="acc-body">Every piece sold by LEKOINDULUXE is guaranteed authentic.</div></details>' +
        '</div></div></div>' +
        (related.length ? '<section class="related"><h2>You may also like</h2>' + grid(related) + '</section>' : '') + '</div>',
      after: function () {
        var err = document.getElementById('pdp-err'), label = view.querySelector('.pdp-label span');
        view.querySelectorAll('.size-btn').forEach(function (b) {
          b.onclick = function () {
            size = b.getAttribute('data-size');
            view.querySelectorAll('.size-btn').forEach(function (x) { var on = x === b; x.classList.toggle('on', on); x.setAttribute('aria-checked', on); });
            label.textContent = 'Size: ' + size; err.textContent = '';
          };
        });
        document.getElementById('pdp-add').onclick = function () {
          if (!size) { err.textContent = 'Please choose a size.'; return; }
          window.LKCart.add(p.id, size);
        };
      }
    };
  }

  /* ---------- Search ---------- */
  function search(q) {
    var t = norm(q).split(/\s+/).filter(Boolean); if (!t.length) return [];
    return C.filter(function (p) {
      var hay = norm([p.name, p.sub, p.type, p.brand || '', p.gender === 'unisex' ? 'men women unisex' : p.gender, p.desc, p.was ? 'sale' : '', p.isNew ? 'new' : ''].join(' '));
      return t.every(function (w) { return hay.indexOf(w) > -1 || (w.length > 3 && hay.indexOf(w.replace(/s$/, '')) > -1); });
    });
  }
  function catMatches(q) {
    var n = norm(q).trim(); if (n.length < 2) return [];
    var out = [];
    ['men', 'women'].forEach(function (g) {
      Object.keys(M[g]).forEach(function (sec) {
        M[g][sec].forEach(function (s) { if (norm(s).indexOf(n) > -1 || norm(GEN[g] + ' ' + s).indexOf(n) > -1) out.push(['' + GEN[g] + ' · ' + s, shopHref(g, sec, slug(s))]); });
        if (norm(SEC[sec]).indexOf(n) > -1) out.push([GEN[g] + ' · ' + SEC[sec], shopHref(g, sec)]);
      });
    });
    return out.slice(0, 8);
  }
  function searchResults(q) {
    var res = search(q), cats = catMatches(q);
    if (!q.trim()) {
      return '<div class="search-meta"><h5>POPULAR SEARCHES</h5><div class="chips">' +
        ['Hoodie', 'Jacket', 'Denim', 'Tee', 'Sale'].map(function (s) { return '<a class="chip" href="#/search/' + encodeURIComponent(s) + '">' + s + '</a>'; }).join('') +
        '</div></div><div class="search-meta"><h5>BEST SELLERS</h5></div>' + grid(C.filter(function (p) { return p.best; }).slice(0, 4));
    }
    return (cats.length ? '<div class="search-meta"><h5>CATEGORIES</h5><div class="chips">' + cats.map(function (c) { return '<a class="chip" href="' + c[1] + '">' + esc(c[0]) + '</a>'; }).join('') + '</div></div>' : '') +
      '<div class="search-meta"><h5>' + res.length + ' PRODUCT' + (res.length === 1 ? '' : 'S') + ' FOR “' + esc(q.toUpperCase()) + '”</h5></div>' +
      (res.length ? grid(res) : '<div class="empty-state"><h2>No match</h2><p>Nothing matches “' + esc(q) + '” yet. Check the spelling, try a broader word, or browse the collection.</p><div class="btn-row"><a class="btn" href="#/shop">Shop all ' + ARROW + '</a></div></div>');
  }
  function searchPage(q) {
    return {
      title: q ? 'Search: ' + q : 'Search',
      html: '<div class="wrap page">' + crumbs([['Home', '#/'], ['Search', '']]) +
        '<form class="search-box" id="search-form" role="search"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>' +
        '<input id="search-input" type="search" placeholder="Search" aria-label="Search products" autocomplete="off" value="' + esc(q) + '">' +
        '<button type="button" id="search-clear"' + (q ? '' : ' hidden') + '>CLEAR</button></form>' +
        '<div id="search-results">' + searchResults(q) + '</div></div>',
      after: function () {
        var inp = document.getElementById('search-input'), out = document.getElementById('search-results'), clr = document.getElementById('search-clear'), timer;
        inp.focus(); inp.setSelectionRange(inp.value.length, inp.value.length);
        function update() {
          var v = inp.value;
          history.replaceState(null, '', '#/search' + (v.trim() ? '/' + encodeURIComponent(v.trim()) : ''));
          document.title = (v.trim() ? 'Search: ' + v.trim() : 'Search') + ' — LEKOINDULUXE';
          out.innerHTML = searchResults(v); clr.hidden = !v; syncWish();
        }
        inp.oninput = function () { clearTimeout(timer); timer = setTimeout(update, 120); };
        clr.onclick = function () { inp.value = ''; update(); inp.focus(); };
        document.getElementById('search-form').onsubmit = function (e) { e.preventDefault(); inp.blur(); };
      }
    };
  }

  /* ---------- Wishlist ---------- */
  function wishlistPage() {
    var list = wish.map(byId).filter(Boolean);
    return {
      title: 'Wishlist',
      html: '<div class="wrap page">' + crumbs([['Home', '#/'], ['Wishlist', '']]) +
        '<div class="page-head"><div><h1 class="page-title">Wishlist</h1><p class="page-sub">Saved on this device. Tap the heart on any piece to add or remove it.</p></div>' +
        (list.length ? '<button class="btn" id="wish-all">Add all to bag</button>' : '') + '</div>' +
        (list.length ? grid(list) :
          '<div class="empty-state"><div class="kicker">NOTHING SAVED YET</div><h2>Your wishlist<br>is empty</h2><p>Tap the ♥ on a piece you love and it will wait for you here.</p><div class="btn-row"><a class="btn" href="#/shop">Shop the collection ' + ARROW + '</a></div></div>') +
        '</div>',
      after: function () {
        var b = document.getElementById('wish-all');
        if (b) b.onclick = function () { list.forEach(function (p) { window.LKCart.add(p.id, defaultSize(p)); }); };
      }
    };
  }

  /* ---------- Track order ---------- */
  function trackPage() {
    return {
      title: 'Track your order',
      html: '<div class="wrap page">' + crumbs([['Home', '#/'], ['Track order', '']]) +
        '<div class="page-head"><div><h1 class="page-title">Track<br>your order</h1><p class="page-sub">Your tracking link is in the shipping email we send the moment your parcel leaves us. Can\'t find it? Enter your details and we\'ll help.</p></div></div>' +
        '<div class="two-col"><form id="track-form" novalidate>' +
        '<label class="f"><span>Order number</span><input id="tr-order" placeholder="#1001" required></label>' +
        '<label class="f"><span>Email used for the order</span><input id="tr-email" type="email" autocomplete="email" required></label>' +
        '<button class="btn" type="submit">' + (S.orderStatusUrl ? 'Check status' : 'Find my order') + ' ' + ARROW + '</button>' +
        '<p class="form-msg" id="tr-msg" role="status"></p></form>' +
        '<div><ol class="steps">' +
        '<li><div><b>Order confirmed</b><p>You receive a confirmation email with your order number.</p></div></li>' +
        '<li><div><b>Prepared</b><p>Your pieces are checked and packed with care.</p></div></li>' +
        '<li><div><b>Shipped</b><p>You get a shipping email with your tracking link.</p></div></li>' +
        '<li><div><b>Delivered</b><p>Something not right? You have 30 days to return it.</p></div></li>' +
        '</ol><p style="margin-top:18px;font-size:13px;color:var(--gray)">Delivery times and costs: <button class="link" data-policy="shipping-policy" style="text-decoration:underline;font-weight:600">Shipping Policy</button></p></div></div></div>',
      after: function () {
        document.getElementById('track-form').onsubmit = function (e) {
          e.preventDefault();
          var o = document.getElementById('tr-order').value.trim(), m = document.getElementById('tr-email').value.trim(), msg = document.getElementById('tr-msg');
          msg.className = 'form-msg';
          if (!o || !/^\S+@\S+\.\S+$/.test(m)) { msg.className = 'form-msg err'; msg.textContent = 'Please enter your order number and a valid email.'; return; }
          if (S.orderStatusUrl) { window.open(S.orderStatusUrl, '_blank', 'noopener'); msg.textContent = 'Opening your order status page…'; return; }
          location.href = 'mailto:' + S.email + '?subject=' + encodeURIComponent('Where is my order ' + o + '?') + '&body=' + encodeURIComponent('Order number: ' + o + '\nEmail: ' + m + '\n\nHello, could you tell me where my order is? Thank you.');
          msg.textContent = 'Your email app is opening with your request. We\'ll reply with your tracking link.';
        };
      }
    };
  }

  /* ---------- Help ---------- */
  var FAQ = [
    ['Orders & delivery', [
      ['delivery', 'How long does delivery take?', 'Orders are prepared in a few business days, then handed to the carrier. Exact times and prices for each option are in our <button class="link" data-policy="shipping-policy">Shipping Policy</button>.'],
      ['free-delivery', 'Is delivery free?', 'Yes, standard delivery is free on orders above $99.'],
      ['tracking', 'Where is my order?', 'Use the tracking link in your shipping email, or go to <a href="#/track">Track order</a>.'],
      ['change', 'Can I change or cancel my order?', 'Email us as soon as possible at <a data-mail href="#"></a> with your order number. Once an order has shipped we can no longer change it, but you can return it.']
    ]],
    ['Returns & refunds', [
      ['returns', 'What is your return policy?', 'You have 30 days from delivery to return unworn, unwashed items with their tags and original packaging. Details in our <button class="link" data-policy="refund-policy">Refund Policy</button>.'],
      ['how-return', 'How do I return an item?', 'Email <a data-mail href="#"></a> with your order number and the items you want to return. We\'ll send the return address and instructions. Please don\'t send anything back before contacting us.'],
      ['refund-time', 'When will I get my refund?', 'Approved refunds go back to your original payment method within 14 days of us receiving the item.'],
      ['exchange', 'Can I exchange a size?', 'The fastest way is to return the item for a refund and place a new order in the right size.'],
      ['faulty', 'My item arrived damaged', 'Contact us within 7 days of delivery with photos and we\'ll arrange a replacement or a full refund.']
    ]],
    ['Sizing', [
      ['sizing', 'How do I choose my size?', 'Each product page shows the sizes available and fit notes (for example “oversized — take your usual size”). Between two sizes, or not sure? Email <a data-mail href="#"></a> with your height and usual size and we\'ll advise you before you order.']
    ]],
    ['Payment & security', [
      ['payment', 'Which payment methods do you accept?', 'All accepted methods are shown at checkout. Payments go through secure payment providers — we never see or store your full card number.'],
      ['code', 'How do I use a discount code?', 'Add your code in the bag before checkout. Only one code can be used per order.']
    ]],
    ['Authenticity', [
      ['authentic', 'Are your products authentic?', 'Yes. Every piece we sell is guaranteed 100% authentic.']
    ]]
  ];
  function helpPage(open) {
    return {
      title: 'Help',
      html: '<div class="wrap page">' + crumbs([['Home', '#/'], ['Help', '']]) +
        '<div class="page-head"><div><h1 class="page-title">How can<br>we help?</h1></div></div>' +
        '<div class="help-grid"><div>' + FAQ.map(function (g) {
          return '<div class="faq-group"><h2>' + g[0].toUpperCase() + '</h2><div class="acc">' + g[1].map(function (f) {
            return '<details id="faq-' + f[0] + '"' + (f[0] === open ? ' open' : '') + '><summary>' + f[1] + '</summary><div class="acc-body">' + f[2] + '</div></details>';
          }).join('') + '</div></div>';
        }).join('') + '</div>' +
        '<aside><div class="card dark"><h3>Contact us</h3><p>Didn\'t find your answer? Write to us — a real person replies.</p><div class="stack"><a data-mail href="#"></a>' +
        (S.instagram ? '<a href="' + esc(S.instagram) + '" target="_blank" rel="noopener">Instagram DM</a>' : '') + '</div></div>' +
        '<div class="card"><h3>Quick links</h3><div class="stack"><a href="#/track">Track my order</a><a href="#/delivery">Delivery &amp; returns</a><a href="#/contact">Contact form</a><a href="#/help/sizing">Size help</a></div></div>' +
        '<div class="card"><h3>Policies</h3><div class="stack"><button data-policy="shipping-policy">Shipping Policy</button><button data-policy="refund-policy">Refund Policy</button><button data-policy="privacy-policy">Privacy Policy</button><button data-policy="terms-of-service">Terms of Service</button><button data-policy="cookie-policy">Cookie Policy</button><button data-policy="legal-notice">Legal Notice</button></div></div></aside></div></div>',
      after: function () {
        view.querySelectorAll('[data-mail]').forEach(function (a) { a.href = 'mailto:' + S.email; a.textContent = S.email; });
        if (open) { var d = document.getElementById('faq-' + open); if (d) setTimeout(function () { d.scrollIntoView({ block: 'center' }); }, 60); }
      }
    };
  }

  /* ---------- App ---------- */
  function appPage() {
    return {
      title: 'App',
      html: '<div class="wrap page">' + crumbs([['Home', '#/'], ['App', '']]) +
        '<div class="page-head"><div><p class="eyebrow">Coming soon</p><h1 class="page-title">The app<br>is coming</h1><p class="page-sub">Until it lands, put LEKOINDULUXE on your home screen. It opens full screen, like an app — two taps.</p></div></div>' +
        '<div class="howto"><div class="card"><h3>iPhone · Safari</h3><ol><li>Open this site in Safari.</li><li>Tap the Share button (square with an arrow).</li><li>Choose “Add to Home Screen”, then “Add”.</li></ol></div>' +
        '<div class="card"><h3>Android · Chrome</h3><ol><li>Open this site in Chrome.</li><li>Tap the ⋮ menu in the top corner.</li><li>Choose “Add to home screen” or “Install app”.</li></ol></div></div>' +
        '<div class="btn-row" style="justify-content:flex-start"><a class="btn" href="#next-drop">Get drop alerts ' + ARROW + '</a><a class="btn btn-line" href="#/shop">Shop now</a></div></div>'
    };
  }

  function notFound() {
    return {
      title: 'Page not found',
      html: '<div class="wrap page"><div class="empty-state"><div class="kicker">ERROR 404</div><h2>Page not found</h2><p>This page doesn\'t exist or has moved.</p><div class="btn-row"><a class="btn" href="#/">Back home ' + ARROW + '</a><a class="btn btn-line" href="#/shop">Shop all</a></div></div></div>'
    };
  }


  /* ---------- Women — coming soon ---------- */
  var WOMEN_IMG = 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?auto=format&fit=crop&w=1400&q=75';
  var SKEY = 'lekoindulux-women-list';
  function signedUp() { try { return localStorage.getItem(SKEY); } catch (e) { return null; } }
  function signup(email, list) {
    // With SITE.signupUrl (Formspree, Klaviyo form, Shopify…) the address is sent there.
    // Without it, the visitor's email app opens a message to SITE.email.
    if (S.signupUrl) {
      var fd = new FormData(); fd.append('email', email); fd.append('list', list);
      return fetch(S.signupUrl, { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(); return 'sent'; });
    }
    location.href = 'mailto:' + S.email + '?subject=' + encodeURIComponent('Notify me — ' + list) +
      '&body=' + encodeURIComponent('Please let me know when the ' + list + ' opens.\n\nMy email: ' + email);
    return Promise.resolve('mail');
  }
  function soonCard() {
    return '<article class="prod-card soon-card"><a class="prod-img" href="#/shop/women">' +
      '<span class="bg" style="background-image:url(\'' + WOMEN_IMG + '\')"></span>' +
      '<span class="k">WOMEN</span><span class="t">Coming<br>soon</span><span class="c">JOIN THE LIST →</span></a>' +
      '<div class="prod-meta"><div><h3><a href="#/shop/women">The women\'s collection</a></h3><p class="cat">Early access for the list</p></div></div></article>';
  }

  /* ---------- Sound (generated in the browser — no audio files) ---------- */
  var FX = (function () {
    var ctx, master, noiseBuf, on = false, amb = null, scr = null;
    function init() {
      if (ctx) return true;
      var AC = window.AudioContext || window.webkitAudioContext; if (!AC) return false;
      ctx = new AC(); master = ctx.createGain(); master.gain.value = .9; master.connect(ctx.destination);
      noiseBuf = ctx.createBuffer(1, ctx.sampleRate * 2, ctx.sampleRate);
      var d = noiseBuf.getChannelData(0); for (var i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
      return true;
    }
    function noise() { var s = ctx.createBufferSource(); s.buffer = noiseBuf; s.loop = true; return s; }
    function env(g, peak, attack, decay, t0) { t0 = t0 || ctx.currentTime; g.gain.setValueAtTime(0.0001, t0); g.gain.exponentialRampToValueAtTime(peak, t0 + attack); g.gain.exponentialRampToValueAtTime(0.0001, t0 + attack + decay); }
    function startAmbient() {
      if (amb) return;
      var g = ctx.createGain(), lp = ctx.createBiquadFilter(), lfo = ctx.createOscillator(), lg = ctx.createGain();
      lp.type = 'lowpass'; lp.frequency.value = 380; g.gain.value = 0;
      var o1 = ctx.createOscillator(), o2 = ctx.createOscillator(), o3 = ctx.createOscillator();
      o1.frequency.value = 55; o2.frequency.value = 82.4; o2.detune.value = 6; o3.type = 'triangle'; o3.frequency.value = 110.3;
      var g3 = ctx.createGain(); g3.gain.value = .25;
      o1.connect(lp); o2.connect(lp); o3.connect(g3); g3.connect(lp); lp.connect(g); g.connect(master);
      lfo.frequency.value = .07; lg.gain.value = .018; lfo.connect(lg); lg.connect(g.gain);
      [o1, o2, o3, lfo].forEach(function (o) { o.start(); });
      g.gain.setTargetAtTime(.045, ctx.currentTime, 1.5);
      amb = { g: g, nodes: [o1, o2, o3, lfo] };
    }
    function stopAmbient() {
      if (!amb) return; var a = amb; amb = null;
      a.g.gain.cancelScheduledValues(ctx.currentTime); a.g.gain.setTargetAtTime(0, ctx.currentTime, .4);
      setTimeout(function () { a.nodes.forEach(function (o) { try { o.stop(); } catch (e) {} }); }, 2000);
    }
    function startScratchBed() {
      if (scr) return;
      var s = noise(), bp = ctx.createBiquadFilter(), hp = ctx.createBiquadFilter(), g = ctx.createGain();
      bp.type = 'bandpass'; bp.Q.value = .9; bp.frequency.value = 2400; hp.type = 'highpass'; hp.frequency.value = 900; g.gain.value = 0;
      s.connect(hp); hp.connect(bp); bp.connect(g); g.connect(master); s.start();
      scr = { s: s, g: g, bp: bp };
    }
    return {
      get on() { return on; },
      enable: function () { if (!init()) return false; ctx.resume(); on = true; startAmbient(); startScratchBed(); return true; },
      disable: function () { on = false; if (!ctx) return; stopAmbient(); if (scr) { scr.g.gain.setTargetAtTime(0, ctx.currentTime, .05); } },
      silence: function () { if (!ctx) return; stopAmbient(); if (scr) { try { scr.s.stop(); } catch (e) {} scr = null; } },
      resume: function () { if (on && ctx) { ctx.resume(); startAmbient(); startScratchBed(); } },
      scratch: function (speed) {
        if (!on || !scr) return; var t = ctx.currentTime, lvl = Math.min(.32, .03 + speed * .006);
        scr.g.gain.cancelScheduledValues(t); scr.g.gain.setTargetAtTime(lvl, t, .015); scr.g.gain.setTargetAtTime(0, t + .07, .06);
        scr.bp.frequency.setTargetAtTime(1600 + Math.min(speed, 60) * 55, t, .03);
      },
      tick: function (vol) {
        if (!on) return; var s = noise(), hp = ctx.createBiquadFilter(), g = ctx.createGain();
        hp.type = 'highpass'; hp.frequency.value = 5000; s.connect(hp); hp.connect(g); g.connect(master);
        env(g, vol || .12, .001, .025); s.start(); s.stop(ctx.currentTime + .05);
      },
      shatter: function () {
        if (!on) return; var t = ctx.currentTime;
        var o = ctx.createOscillator(), og = ctx.createGain(); o.frequency.setValueAtTime(95, t); o.frequency.exponentialRampToValueAtTime(32, t + .6);
        o.connect(og); og.connect(master); env(og, .9, .005, .9, t); o.start(t); o.stop(t + 1.1);
        var n = noise(), hp = ctx.createBiquadFilter(), ng = ctx.createGain(); hp.type = 'highpass'; hp.frequency.value = 2500;
        n.connect(hp); hp.connect(ng); ng.connect(master); env(ng, .35, .002, .45, t); n.start(t); n.stop(t + .6);
        for (var i = 0; i < 7; i++) {
          var p = ctx.createOscillator(), pg = ctx.createGain(), st = t + .02 + Math.random() * .35;
          p.frequency.value = 2200 + Math.random() * 3800; p.connect(pg); pg.connect(master);
          env(pg, .05 + Math.random() * .04, .002, .5 + Math.random() * .8, st); p.start(st); p.stop(st + 1.5);
        }
      },
      rumble: function () {
        if (!on) return; var t = ctx.currentTime, s = noise(), lp = ctx.createBiquadFilter(), g = ctx.createGain();
        lp.type = 'lowpass'; lp.frequency.setValueAtTime(120, t); lp.frequency.linearRampToValueAtTime(420, t + 1.4);
        s.connect(lp); lp.connect(g); g.connect(master); g.gain.setValueAtTime(.0001, t); g.gain.exponentialRampToValueAtTime(.5, t + .3); g.gain.exponentialRampToValueAtTime(.0001, t + 1.7); s.start(t); s.stop(t + 1.8);
        var o = ctx.createOscillator(), og = ctx.createGain(); o.frequency.setValueAtTime(55, t + 1.35); o.frequency.exponentialRampToValueAtTime(40, t + 2.5); o.connect(og); og.connect(master); env(og, .5, .005, 1.2, t + 1.35); o.start(t + 1.35); o.stop(t + 2.7);
        [1318.5, 1975.5].forEach(function (f, i) { var p = ctx.createOscillator(), pg = ctx.createGain(); p.frequency.value = f; p.connect(pg); pg.connect(master); env(pg, .035, .01, 1.6, t + 1.4 + i * .1); p.start(t + 1.4 + i * .1); p.stop(t + 3.2); });
      },
      chime: function () {
        if (!on) return; var t = ctx.currentTime;
        [659.3, 987.8, 1318.5].forEach(function (f, i) { var o = ctx.createOscillator(), g = ctx.createGain(); o.frequency.value = f; o.connect(g); g.connect(master); env(g, .09, .01, 1.4, t + i * .09); o.start(t + i * .09); o.stop(t + i * .09 + 1.6); });
      }
    };
  })();

  /* ---------- Women — boutique doors experience ---------- */
  var WX_IMGS = [
    WOMEN_IMG,
    'https://images.unsplash.com/photo-1509631179647-0177331693ae?auto=format&fit=crop&w=1200&q=75',
    'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&w=1200&q=75'
  ];
  var WX_FRAMES = [
    ['Silhouette', 0, '38% 18%', '300%'], ['Movement', 1, '50% 55%', '190%'], ['Detail', 0, '52% 62%', '420%'], ['Light', 2, '50% 40%', '220%'],
    ['Attitude', 0, '60% 34%', '260%'], ['Texture', 1, '46% 78%', '320%'], ['Chapter one', 2, '30% 60%', '300%'], ['Soon', 1, '52% 30%', '240%'],
    ['Form', 0, '44% 8%', '360%'], ['Shape', 2, '70% 50%', '260%'], ['Essence', 1, '40% 40%', '380%'], ['Women', 0, '50% 45%', '200%']
  ];
  var WX_DECK = [0, 2, 4, 1, 5, 3, 8, 11];
  var wxSeenLoader = false, wxSoundWanted = false;

  function splitChars(t, d0, step) { return t.split('').map(function (c, i) { return '<span class="ch" style="transition-delay:' + (d0 + i * step) + 'ms">' + (c === ' ' ? '&nbsp;' : esc(c)) + '</span>'; }).join(''); }

  function womenPage() {
    var done = signedUp();
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var showLoader = !wxSeenLoader && !reduce;
    var formHtml = done ? '<div class="wl-done">✓ YOU\'RE ON THE LIST — WE\'LL LET YOU KNOW FIRST.</div>' :
      '<form class="wl-form" id="wl-form" novalidate><label for="wl-email" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)">Email address</label>' +
      '<input type="email" id="wl-email" placeholder="YOUR EMAIL ADDRESS" autocomplete="email" required><button type="submit" class="btn btn-light">Notify me</button></form>' +
      '<p class="wl-legal">We\'ll only email you about the women\'s launch and LEKOINDULUXE news. Unsubscribe anytime. <button type="button" data-policy="privacy-policy">Privacy Policy</button></p>';
    return {
      title: 'Women — Coming soon',
      html: '<div class="wx" id="wx">' +
        (showLoader ? '<div class="wx-loader" id="wx-loader" aria-hidden="true"><div>' + document.getElementById('lk-logo-tpl').innerHTML + '<p>WOMEN — CHAPTER ONE</p></div></div>' : '') +
        '<section class="wx-hero" id="wx-hero" aria-labelledby="wx-title">' +
          '<img class="wx-bg" src="' + WOMEN_IMG + '" alt="" onerror="this.style.opacity=0">' +
          '<div class="wx-shade"></div>' +
          '<div class="wrap wx-hero-in"><div>' + crumbs([['Home', '#/'], ['Women', '']]) +
            '<p class="eyebrow wx-fade">Women — Chapter one</p>' +
            '<h1 class="wx-title" id="wx-title"><span class="ln">' + splitChars('WOMEN', 0, 45) + '</span><span class="ln o">' + splitChars('COMING SOON', 260, 35) + '</span></h1>' +
            '<p class="wx-lead wx-fade" style="transition-delay:.5s">Our first women\'s collection is on its way — ready-to-wear, shoes and accessories chosen with the same eye as everything we do.</p>' +
            '<div class="wx-cta wx-fade" style="transition-delay:.65s"><button type="button" class="btn btn-light" id="wx-early">Get early access</button><button type="button" class="wx-replay" id="wx-replay">↺ CLOSE THE DOORS</button></div>' +
          '</div></div>' +
          '<div class="wx-doors" id="wx-doors" role="button" tabindex="0" aria-label="Open the doors to the women\'s collection">' +
            '<div class="wx-door l"><span>WO</span><i class="handle"></i><i class="sheen"></i></div>' +
            '<div class="wx-door r"><span>MEN</span><i class="handle"></i><i class="sheen"></i></div>' +
            '<i class="wx-gap"></i><span class="wx-enter">✦ ENTER THE BOUTIQUE ✦</span></div>' +
          '<div class="wx-scroll wx-fade" style="transition-delay:.9s">SCROLL ↓</div>' +
        '</section>' +
        '<section class="wx-deck-sec" id="wx-deck-sec" aria-label="A first look"><div class="wx-sticky">' +
          '<div class="wx-deck-head"><p class="eyebrow">A first look</p></div>' +
          '<div class="wx-deck-side l" aria-hidden="true" id="wx-sl">Chap<br>ter</div><div class="wx-deck-side r" aria-hidden="true" id="wx-sr">One</div>' +
          '<div class="wx-deck" id="wx-deck">' + WX_DECK.map(function (k, i) {
            var f = WX_FRAMES[k];
            return '<div class="wx-card" style="z-index:' + (40 - i) + '"><i style="background-image:url(\'' + WX_IMGS[f[1]] + '\');background-position:' + f[2] + ';background-size:' + f[3] + '"></i><div class="lbl"><b>' + f[0] + '</b><span>0' + (i + 1) + ' / 0' + WX_DECK.length + '</span></div></div>';
          }).join('') +
          '<div class="wx-card wx-invite" id="wx-invite" style="z-index:1"><div>' +
            '<div class="k"><span>✦ YOU\'RE INVITED</span><span>LEKOINDULUXE</span></div>' +
            '<h3>Women<span>Chapter one</span></h3>' +
            '<p class="t">Be the first to know when it opens — and get early access before everyone else.</p></div>' +
            '<div>' + formHtml + '<p class="wl-msg" id="wl-msg" role="status"></p></div>' +
          '</div></div>' +
          '<div class="wx-dots" id="wx-dots" aria-hidden="true">' + WX_DECK.map(function () { return '<i></i>'; }).join('') + '<i class="inv"></i></div>' +
          '<p class="wx-deck-hint" id="wx-hint">SCROLL TO DEAL THE CARDS</p>' +
        '</div></section>' +
        '<div class="wrap wl-foot"><p>MEANWHILE, DISCOVER</p><div class="btn-row"><a class="btn btn-light" href="#/shop/men">Shop men ' + ARROW + '</a><a class="btn btn-line" href="#/shop/all/best">Best sellers</a></div></div>' +
        '<button type="button" class="wx-sound' + (wxSoundWanted ? ' on' : '') + '" id="wx-sound" aria-pressed="' + wxSoundWanted + '"><span class="wx-bars" aria-hidden="true"><i></i><i></i><i></i><i></i></span><span id="wx-sound-t">SOUND ' + (wxSoundWanted ? 'ON' : 'OFF') + '</span></button>' +
        '<div class="wx-cursor" id="wx-cursor" aria-hidden="true"></div>' +
      '</div>',
      after: function () { return wxInit(showLoader, reduce); }
    };
  }

  function wxInit(showLoader, reduce) {
    var $ = function (id) { return document.getElementById(id); };
    var hero = $('wx-hero'), doors = $('wx-doors');
    var ringRaf = 0, curRaf = 0, dead = false, offs = [], timers = [], opened = false;
    function on(t, ev, fn, o) { t.addEventListener(ev, fn, o); offs.push(function () { t.removeEventListener(ev, fn, o); }); }
    function later(fn, ms) { timers.push(setTimeout(fn, ms)); }
    var fine = window.matchMedia && matchMedia('(pointer: fine)').matches;
    var tilt = { x: 0, y: 0 };

    /* sound toggle */
    var sb = $('wx-sound');
    if (wxSoundWanted) FX.resume();
    sb.onclick = function () {
      wxSoundWanted = !FX.on;
      if (wxSoundWanted) { if (!FX.enable()) { wxSoundWanted = false; return; } FX.tick(.2); } else FX.disable();
      sb.classList.toggle('on', wxSoundWanted); sb.setAttribute('aria-pressed', wxSoundWanted); $('wx-sound-t').textContent = 'SOUND ' + (wxSoundWanted ? 'ON' : 'OFF');
    };

    /* loader: the wordmark draws itself, once per visit */
    if (showLoader) {
      wxSeenLoader = true;
      var L = $('wx-loader');
      later(function () { L.classList.add('out'); later(function () { L.remove(); }, 750); }, 2350);
    }

    /* doors */
    function openDoors() {
      if (opened) return; opened = true;
      var cc = document.getElementById('wx-cursor'); if (cc) cc.classList.remove('open-lbl');
      if (FX.on) FX.resume();
      FX.rumble();
      if (reduce) { doors.hidden = true; hero.classList.add('in'); return; }
      doors.classList.add('open'); hero.classList.add('opening');
      later(function () { hero.classList.add('in'); }, 700);
      later(function () { if (opened) doors.hidden = true; }, 1700);
    }
    on(doors, 'click', openDoors);
    on(doors, 'keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openDoors(); } });
    $('wx-replay').onclick = function () {
      opened = false; FX.tick(.12);
      hero.classList.remove('in', 'opening');
      doors.hidden = false; doors.classList.add('open');
      hero.scrollIntoView({ behavior: 'smooth', block: 'end' });
      requestAnimationFrame(function () { requestAnimationFrame(function () { doors.classList.remove('open'); }); });
    };

    /* phone tilt */
    on(window, 'deviceorientation', function (e) {
      if (e.gamma == null) return;
      tilt.x = Math.max(-.4, Math.min(.4, e.gamma / 60)); tilt.y = Math.max(-.4, Math.min(.4, (e.beta - 45) / 90));
    });
    on(doors, 'pointerdown', function () {
      if (typeof DeviceOrientationEvent !== 'undefined' && DeviceOrientationEvent.requestPermission && !wxInit.asked) { wxInit.asked = true; DeviceOrientationEvent.requestPermission().catch(function () {}); }
    });

    /* card deck: each scroll throws the top card, the invitation is last */
    var dsec = $('wx-deck-sec'), dcards = document.querySelectorAll('#wx-deck .wx-card'), ddots = document.querySelectorAll('#wx-dots i'), NP = dcards.length - 1, sm = 0, lastCur = -1, hintEl = $('wx-hint');
    (function deckLoop() {
      if (dead) return;
      var r = dsec.getBoundingClientRect();
      if (r.bottom > 0 && r.top < innerHeight) {
        var p = Math.max(0, Math.min(1, -r.top / Math.max(1, r.height - innerHeight)));
        var target = Math.min(NP, p * (NP + .45));
        sm += (target - sm) * (reduce ? 1 : .1);
        for (var i = 0; i <= NP; i++) {
          var d = i - sm, c = dcards[i], side = i % 2 ? 1 : -1;
          if (i < NP && d < -1.2) { c.style.opacity = 0; c.style.pointerEvents = 'none'; continue; }
          if (i < NP && d < 0) {
            var k = -d; c.style.opacity = 1 - Math.max(0, (k - .45) / .55); c.style.filter = 'none';
            c.style.transform = 'translate3d(' + (k * side * 70) + 'vw,' + (-k * 30) + 'vh,' + (k * 300) + 'px) rotate(' + (k * side * 28) + 'deg)';
          } else {
            var dd = Math.max(0, d);
            c.style.opacity = dd > 4 ? 0 : 1;
            c.style.transform = 'translate3d(' + (dd * 14) + 'px,' + (dd * -14) + 'px,' + (-dd * 60) + 'px) rotate(' + (dd * side * 2.5) + 'deg)';
            c.style.filter = 'brightness(' + (1 - Math.min(.7, dd * .18)) + ')';
          }
          c.style.pointerEvents = (i === NP && d < .5) ? 'auto' : 'none';
        }
        var cur = Math.min(NP, Math.round(sm));
        if (cur !== lastCur) { ddots.forEach(function (x, j) { x.classList.toggle('on', j === cur); }); if (lastCur > -1) FX.tick(.08); lastCur = cur; }
        hintEl.style.opacity = cur >= NP ? 0 : 1;
        $('wx-sl').style.transform = 'translateY(calc(-50% + ' + (sm * -12) + 'px))';
        $('wx-sr').style.transform = 'translateY(calc(-50% + ' + (sm * 12) + 'px))';
      }
      ringRaf = requestAnimationFrame(deckLoop);
    })();
    function toInvite() {
      var top = dsec.getBoundingClientRect().top + scrollY + dsec.offsetHeight - innerHeight;
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' }); FX.tick(.12);
      var inp = $('wl-email'); if (inp) setTimeout(function () { inp.focus({ preventScroll: true }); }, 1400);
    }

    /* custom cursor */
    var c$ = $('wx-cursor'), cx = -100, cy = -100, tx2 = -100, ty2 = -100;
    if (fine) {
      c$.classList.add('show');
      on(window, 'pointermove', function (e) {
        tx2 = e.clientX; ty2 = e.clientY;
        var overDoors = !opened && !!(e.target.closest && e.target.closest('#wx-doors'));
        c$.classList.toggle('open-lbl', overDoors);
        c$.classList.toggle('big', !overDoors && !!(e.target.closest && e.target.closest('#wx a, #wx button')));
      });
      (function cl() { if (dead) return; cx += (tx2 - cx) * .25; cy += (ty2 - cy) * .25; c$.style.transform = 'translate(' + cx + 'px,' + cy + 'px)'; curRaf = requestAnimationFrame(cl); })();
    }

    /* scroll buttons + sign-up */
    $('wx-early').onclick = toInvite;
    var f = $('wl-form');
    if (f) f.onsubmit = function (e) {
      e.preventDefault();
      var inp = $('wl-email'), msg = $('wl-msg'), v = inp.value.trim();
      msg.className = 'wl-msg';
      if (!/^\S+@\S+\.\S+$/.test(v)) { msg.className = 'wl-msg err'; msg.textContent = 'Please enter a valid email address.'; inp.focus(); return; }
      var b = f.querySelector('button'); b.disabled = true;
      signup(v, 'Women launch').then(function (how) {
        FX.chime();
        if (how === 'sent') {
          try { localStorage.setItem(SKEY, v); } catch (e) {}
          f.outerHTML = '<div class="wl-done wx-joined">✓ YOU\'RE ON THE LIST — WE\'LL LET YOU KNOW FIRST.</div>'; msg.textContent = '';
        } else { b.disabled = false; msg.textContent = 'Your email app is opening — just press send and you\'re on the list.'; }
      }).catch(function () { b.disabled = false; msg.className = 'wl-msg err'; msg.textContent = 'Something went wrong. Please try again, or email us at ' + S.email + '.'; });
    };

    return function cleanup() {
      dead = true; cancelAnimationFrame(ringRaf); cancelAnimationFrame(curRaf);
      timers.forEach(clearTimeout); offs.forEach(function (o) { o(); }); FX.silence();
    };
  }

  /* ---------- Delivery & returns ---------- */
  function deliveryPage() {
    return {
      title: 'Delivery & returns',
      html: '<div class="wrap page">' + crumbs([['Home', '#/'], ['Help', '#/help'], ['Delivery & returns', '']]) +
        '<div class="page-head"><div><h1 class="page-title">Delivery<br>&amp; returns</h1><p class="page-sub">Everything about getting your order, and sending it back if it isn\'t right.</p></div></div>' +
        '<p class="eyebrow">Delivery</p><h2 class="dr-h">How fast it arrives</h2>' +
        '<div class="dr-grid">' +
          '<div class="dr-card dark"><p class="k">STANDARD</p><b><mark>[3–5]</mark> days</b><p>Business days after dispatch. <strong style="color:#fff">Free on orders above $99</strong>, otherwise <mark>[$X]</mark>.</p></div>' +
          '<div class="dr-card"><p class="k">EXPRESS</p><b><mark>[1–2]</mark> days</b><p>Business days after dispatch — <mark>[$X]</mark>.</p></div>' +
          '<div class="dr-card"><p class="k">INTERNATIONAL</p><b><mark>[5–12]</mark> days</b><p>Price calculated at checkout. Duties may apply outside the EU.</p></div>' +
        '</div>' +
        '<div class="two-col" style="margin-bottom:64px"><ol class="steps">' +
          '<li><div><b>Prepared</b><p>Orders are packed within <mark>[1–3]</mark> business days (Monday to Friday).</p></div></li>' +
          '<li><div><b>Shipped</b><p>You get an email with your tracking link the moment it leaves us.</p></div></li>' +
          '<li><div><b>Delivered</b><p>Track it anytime on the <a href="#/track" style="text-decoration:underline">Track order</a> page.</p></div></li>' +
        '</ol><div class="card"><h3>Where we ship</h3><p><mark>[List of countries / regions]</mark></p><div class="stack"><button data-policy="shipping-policy">Read the full Shipping Policy</button></div></div></div>' +
        '<p class="eyebrow">Returns</p><h2 class="dr-h">30 days to change your mind</h2>' +
        '<div class="dr-grid">' +
          '<div class="dr-card"><p class="k">01</p><b>Email us</b><p>Write to <a data-mail href="#" style="text-decoration:underline"></a> with your order number and the items to return.</p></div>' +
          '<div class="dr-card"><p class="k">02</p><b>Send it back</b><p>Unworn, unwashed, with tags and original packaging. Return shipping is <mark>[free / at your expense]</mark>.</p></div>' +
          '<div class="dr-card"><p class="k">03</p><b>Get refunded</b><p>To your original payment method within 14 days of us receiving the item.</p></div>' +
        '</div>' +
        '<div class="two-col"><div class="card"><h3>Arrived damaged?</h3><p>Contact us within 7 days of delivery with photos — we\'ll send a replacement or a full refund.</p></div>' +
        '<div class="card"><h3>Need another size?</h3><p>Return the item for a refund and place a new order in the size you need — it\'s the fastest way.</p><div class="stack"><button data-policy="refund-policy">Read the full Refund Policy</button><a href="#/contact">Contact us</a></div></div></div></div>',
      after: function () { view.querySelectorAll('[data-mail]').forEach(function (a) { a.href = 'mailto:' + S.email; a.textContent = S.email; }); }
    };
  }

  /* ---------- Contact ---------- */
  function contactPage() {
    return {
      title: 'Contact',
      html: '<div class="wrap page">' + crumbs([['Home', '#/'], ['Contact', '']]) +
        '<div class="page-head"><div><h1 class="page-title">Get in<br>touch</h1><p class="page-sub">A question about an order, a size or a piece? Write to us — a real person replies.</p></div></div>' +
        '<div class="help-grid"><form id="ct-form" novalidate>' +
          '<div class="f-row"><label class="f"><span>Name</span><input id="ct-name" autocomplete="name" required></label>' +
          '<label class="f"><span>Email</span><input id="ct-email" type="email" autocomplete="email" required></label></div>' +
          '<div class="f-row"><label class="f"><span>Subject</span><select id="ct-subject"><option>Order &amp; delivery</option><option>Returns &amp; refunds</option><option>Product or size question</option><option>Press &amp; partnerships</option><option>Something else</option></select></label>' +
          '<label class="f"><span>Order number (optional)</span><input id="ct-order" placeholder="#1001"></label></div>' +
          '<label class="f"><span>Message</span><textarea id="ct-msg" required></textarea></label>' +
          '<button class="btn" type="submit">Send message ' + ARROW + '</button><p class="form-msg" id="ct-out" role="status"></p>' +
        '</form><aside>' +
          '<div class="card dark"><h3>Email</h3><p>We reply <mark style="background:#333;color:#fff">[within 1–2 business days]</mark>.</p><div class="stack"><a data-mail href="#"></a></div></div>' +
          (S.instagram ? '<div class="card"><h3>Instagram</h3><p>Send us a DM.</p><div class="stack"><a href="' + esc(S.instagram) + '" target="_blank" rel="noopener">Open Instagram</a></div></div>' : '') +
          '<div class="card"><h3>Quick answers</h3><div class="stack"><a href="#/track">Track my order</a><a href="#/delivery">Delivery &amp; returns</a><a href="#/help">Help &amp; FAQ</a></div></div>' +
        '</aside></div></div>',
      after: function () {
        view.querySelectorAll('[data-mail]').forEach(function (a) { a.href = 'mailto:' + S.email; a.textContent = S.email; });
        document.getElementById('ct-form').onsubmit = function (e) {
          e.preventDefault();
          var g = function (id) { return document.getElementById(id).value.trim(); }, out = document.getElementById('ct-out');
          out.className = 'form-msg';
          if (!g('ct-name') || !/^\S+@\S+\.\S+$/.test(g('ct-email')) || g('ct-msg').length < 5) { out.className = 'form-msg err'; out.textContent = 'Please add your name, a valid email and a message.'; return; }
          location.href = 'mailto:' + S.email + '?subject=' + encodeURIComponent(g('ct-subject') + (g('ct-order') ? ' — order ' + g('ct-order') : '')) +
            '&body=' + encodeURIComponent(g('ct-msg') + '\n\n—\n' + g('ct-name') + '\n' + g('ct-email') + (g('ct-order') ? '\nOrder: ' + g('ct-order') : ''));
          out.textContent = 'Your email app is opening with your message — just press send.';
        };
      }
    };
  }

  /* ---------- Footer: newsletter, logo animation, payments, back to top ---------- */
  (function () {
    var y = document.getElementById('ft-year'); if (y) y.textContent = new Date().getFullYear();
    var reg = document.getElementById('ft-region'); if (reg) reg.textContent = (S.region + ' · ' + S.currency).toUpperCase();
    var pay = document.getElementById('ft-pay'); if (pay) { pay.innerHTML = (S.payments || []).map(function (m) { return '<span>' + esc(m).toUpperCase() + '</span>'; }).join(''); pay.hidden = !(S.payments || []).length; }
    var top = document.getElementById('ft-top'); if (top) top.onclick = function () { window.scrollTo({ top: 0, behavior: 'smooth' }); };
    var logo = document.getElementById('ft-logo');
    if (logo) {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en, ob) { en.forEach(function (x) { if (x.isIntersecting) { logo.classList.add('in'); ob.disconnect(); } }); }, { threshold: .35 }).observe(logo);
      } else logo.classList.add('in');
    }
    var f = document.getElementById('ft-form');
    if (f) f.onsubmit = function (e) {
      e.preventDefault();
      var inp = document.getElementById('ft-email'), msg = document.getElementById('ft-msg'), v = inp.value.trim();
      msg.className = 'ft-msg';
      if (!/^\S+@\S+\.\S+$/.test(v)) { msg.className = 'ft-msg err'; msg.textContent = 'Please enter a valid email address.'; return; }
      signup(v, 'Newsletter').then(function (how) {
        if (how === 'sent') { f.outerHTML = '<div class="wl-done">✓ YOU\'RE SUBSCRIBED. WELCOME.</div>'; msg.textContent = ''; }
        else msg.textContent = 'Your email app is opening — just press send and you\'re subscribed.';
      }).catch(function () { msg.className = 'ft-msg err'; msg.textContent = 'Something went wrong. Please try again.'; });
    };
  })();

  /* ---------- Router ---------- */
  var current = '', cleanupFn = null;
  function runCleanup() { if (cleanupFn) { try { cleanupFn(); } catch (e) {} cleanupFn = null; } }
  function closeMenus() {
    var m = document.getElementById('menu'); if (m) m.checked = false;
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    if (document.querySelector('.nav-left:hover')) header.classList.add('no-mega');
  }
  ['mouseleave', 'mouseenter'].forEach(function (ev) { document.querySelector('.nav-left').addEventListener(ev, function () { header.classList.remove('no-mega'); }); });
  document.querySelector('.nav-left').addEventListener('focusin', function () { header.classList.remove('no-mega'); });

  function showHome(hash) {
    current = ''; runCleanup();
    var wasHidden = main.hidden;
    view.hidden = true; view.innerHTML = ''; main.hidden = false; document.title = HOME_TITLE;
    if (wasHidden) window.dispatchEvent(new Event('resize'));
    var el = hash && hash.length > 1 && hash.charAt(1) !== '/' ? document.getElementById(hash.slice(1)) : null;
    if (el && el.tagName !== 'DIALOG') setTimeout(function () { el.scrollIntoView({ behavior: 'smooth' }); }, 30);
    else if (!el) window.scrollTo(0, 0);
  }
  function route() {
    var h = location.hash;
    if (h.indexOf('#/') !== 0 || h === '#/') { if (!document.querySelector('dialog.policy[open]')) showHome(h); closeMenus(); return; }
    var raw = h.slice(2).split('?'), q = new URLSearchParams(raw[1] || '');
    var parts = raw[0].split('/').filter(Boolean).map(function (x) { try { return decodeURIComponent(x); } catch (e) { return x; } });
    current = parts[0];
    var page;
    switch (parts[0]) {
      case 'shop': page = shopPage(parts.slice(1), q); break;
      case 'product': page = productPage(parts[1]); break;
      case 'search': page = searchPage(parts.slice(1).join('/')); break;
      case 'wishlist': page = wishlistPage(); break;
      case 'track': page = trackPage(); break;
      case 'help': page = helpPage(parts[1]); break;
      case 'app': page = appPage(); break;
      case 'delivery': page = deliveryPage(); break;
      case 'contact': page = contactPage(); break;
      default: page = notFound();
    }
    runCleanup();
    main.hidden = true; view.hidden = false; view.innerHTML = page.html;
    document.title = page.title + ' — LEKOINDULUXE';
    window.scrollTo(0, 0);
    closeMenus();
    var c = page.after ? page.after() : null; if (typeof c === 'function') cleanupFn = c;
    syncWish();
  }
  window.addEventListener('hashchange', route);

  /* ---------- Global clicks: wishlist hearts + quick add ---------- */
  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-wish]');
    if (w) { e.preventDefault(); toggleWish(w.getAttribute('data-wish')); return; }
    var qa = e.target.closest('[data-quick]');
    if (qa) {
      e.preventDefault();
      var p = byId(qa.getAttribute('data-quick')); if (!p) return;
      window.LKCart.add(p.id, defaultSize(p));
      var t = qa.textContent; qa.textContent = 'ADDED ✓'; setTimeout(function () { qa.textContent = t; }, 1200);
    }
  });

  /* ---------- Home page: best sellers + social links ---------- */
  var hb = document.getElementById('home-best');
  if (hb) hb.innerHTML = C.filter(function (p) { return p.best; }).slice(0, womenSoon ? 3 : 4).map(card).join('') + (womenSoon ? soonCard() : '');
  document.querySelectorAll('[data-social]').forEach(function (a) {
    var url = S[a.getAttribute('data-social')];
    if (url) { a.href = url; a.target = '_blank'; a.rel = 'noopener'; } else a.hidden = true;
  });

  syncWish();
  route();
})();
